/* Booze Buddies v2. Plain JavaScript, no build step, no libraries. */
(() => {
'use strict';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

const CAT = window.BB_CATALOG || [];
// the store's text arrives with HTML entities (&amp;, &rsquo;); the script writes text, so turn them back into characters
if (window.BB_ASSETS) { const t = document.createElement('textarea'), dec = s => { t.innerHTML = s; return t.value; }; CAT.forEach(p => { p.t = dec(p.t); p.l = dec(p.l || ''); p.e = dec(p.e || ''); p.d = (p.d || []).map(dec); p.c = (p.c || []).filter(c => !/^(every-damn-shirt|all|frontpage)$/.test(c)); }); }      // and every shirt's "every damn shirt" collection says nothing about its kind
const BY = Object.fromEntries(CAT.map(p => [p.h, p]));
const STORE = 'https://boozebuddies.shop';
const ON_STORE = /(^|\.)boozebuddies\.shop$|\.myshopify\.com$/.test(location.hostname);
const FREE_AT = 75;
const money = n => '$' + Number(n).toFixed(2);
const pic = (src, w) => src + (src.includes('?') ? '&' : '?') + 'width=' + w;
const calm = matchMedia('(prefers-reduced-motion: reduce)');
// a phone's shirt slot in the hero is under 300px wide, so it gets a smaller picture than a desktop's
const heroPicW = () => innerWidth <= 900 ? 640 : 1000;
// in the local preview a shirt opens the preview's own product page; on the store it is the real product page
const productUrl = h => ON_STORE ? '/products/' + h : 'product.html?h=' + h;
// pictures and art: the preview keeps them in folders under assets/; the Shopify theme keeps every file flat in its assets as bb-*
// (window.BB_ASSETS is the theme's assets address, set by the layout). wild/reel.* is bb-reel.*, wild/x is bb-wild-x, coasters/x is bb-coaster-x.
const ASSETS = window.BB_ASSETS || null;
const asset = f => {
  if (!ASSETS) return 'assets/' + f;
  const flat = f.replace(/^wild\/reel/, 'reel').replace(/^wild\//, 'wild-').replace(/^coasters\//, 'coaster-').replace(/^popouts\//, '');
  return ASSETS + 'bb-' + flat;
};
// a photo of someone in a shirt: a short name means one of the theme's own photos, a full address an upload from the store's files
const shot = f => /[/:]/.test(f) ? f : asset('wild/' + f + '.webp');
// on Shopify, sections hand the script their editor settings as JSON in a <script type="application/json" data-bb="name"> tag
const fromPage = (name, fallback) => { const n = document.querySelector('script[data-bb="' + name + '"]'); if (!n) return fallback; try { return JSON.parse(n.textContent); } catch (e) { return fallback; } };
// the five loud colors, and a way to pick the one that stands off most from a shirt: average the shirt's picture, take the farthest
const STAGES = [{ c: '#FFC637', on: '#0E1A2B', rgb: [255, 198, 55] }, { c: '#23B8D9', on: '#0E1A2B', rgb: [35, 184, 217] }, { c: '#F97020', on: '#0E1A2B', rgb: [249, 112, 32] }, { c: '#E3212A', on: '#FDFDEF', rgb: [227, 33, 42] }, { c: '#1A324E', on: '#FDFDEF', rgb: [26, 50, 78] }];
function stageColor(src, done) {
  const im = new Image(); im.crossOrigin = 'anonymous';
  im.onload = () => {
    try {
      const c = document.createElement('canvas'); c.width = c.height = 32;
      const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, 32, 32);
      const d = x.getImageData(0, 0, 32, 32).data; let r = 0, g = 0, b = 0, n = 0;
      for (let i = 0; i < d.length; i += 4) if (d[i + 3] > 200) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      if (!n) return done(null, []);
      r /= n; g /= n; b /= n;
      const far = s => (s.rgb[0] - r) ** 2 * 2 + (s.rgb[1] - g) ** 2 * 4 + (s.rgb[2] - b) ** 2 * 3;
      const ranked = STAGES.slice().sort((a, b2) => far(b2) - far(a));      // best first
      done(ranked[0], ranked);
    } catch (e) { done(null, []); }      // a picture that cannot be read keeps the color it was given
  };
  im.onerror = () => done(null, []);
  im.src = pic(src, 64);
}
// cards on a dark section never go navy: it fades into the background. Orange takes navy's place in the ranking.
const noNavy = ranked => { const orange = ranked.find(x => x.c === '#F97020'); return ranked.filter(x => x !== orange).map(x => x.c === '#1A324E' ? orange : x); };
// a row of cards: each takes its best color, or its second best when the card before it already has that one.
// The rows ("Pick your Poison", "Next round") sit on dark sections, so no navy here either (2026-10-27).
function stageRow(cards, srcOf) {
  const ranks = new Array(cards.length); let left = cards.length;
  cards.forEach((card, i) => stageColor(srcOf(card), (best, ranked) => {
    ranks[i] = noNavy(ranked);
    if (--left) return;
    // the cards beside it may have a color of their own (set in the editor), so it steers clear of both neighbors' colors;
    // the one before it is already settled, the one after counts only when its color is its own
    const colorOf = n => n && n.classList.contains('pcard') ? (n.style.getPropertyValue('--c') || '').trim().toUpperCase() : null;
    cards.forEach((c, k) => {
      const prev = c.previousElementSibling, next = c.nextElementSibling;
      const avoid = [colorOf(prev), next && !next.dataset.auto ? colorOf(next) : null];
      const pickd = ranks[k].find(s => !avoid.includes(s.c)) || ranks[k][0]; if (!pickd) return;
      c.style.setProperty('--c', pickd.c); c.style.setProperty('--on', pickd.on);
    });
  }));
}
// a label whose words roll up on hover while a fresh copy rolls in from below
function roll(text) {
  const w = el('span', 'roll'), a = el('span', '', text), b = el('span', '', text); b.setAttribute('aria-hidden', 'true');
  w.append(a, b); w.set = t => { a.textContent = t; b.textContent = t; };
  return w;
}
$$('.pill').forEach(n => { const t = n.textContent.trim(); n.textContent = ''; n.append(roll(t)); });

/* ---------- the menu: one button in the top bar that opens a panel of big links ----------
   The links come from the plain row already in the page (it stays as the menu when there is no script). Each carries the name of
   the picture that pops in beside it on rollover: a shirt, the skull, or one of the glasses. */
const Menu = (() => {
  const bar = $('#topbar'), row = $$('.top__links a'), right = $('.top__right');
  if (!bar || !row.length || !right) return null;
  // the bar's new order: Shop shirts on the left, logo in the middle, Cart and the menu button on the right
  const left = el('div', 'top__left'), shop = $('.pill', right);
  if (shop) left.append(shop);
  $('.top__links').after(left);
  const btn = el('button', 'menubtn'); btn.type = 'button'; btn.id = 'menuOpen';
  btn.setAttribute('aria-label', 'Menu'); btn.setAttribute('aria-haspopup', 'dialog'); btn.setAttribute('aria-controls', 'menu'); btn.setAttribute('aria-expanded', 'false');
  btn.append(el('i'), el('i')); right.append(btn);

  const box = el('aside', 'menu'); box.id = 'menu';
  box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Menu'); box.setAttribute('aria-hidden', 'true');
  const top = el('div', 'menu__top'), x = el('button', 'menu__x', '\u2715');
  x.type = 'button'; x.setAttribute('aria-label', 'Close menu'); top.append(x);
  const list = el('nav', 'menu__links'); list.setAttribute('aria-label', 'Menu');
  const layer = (file, cls) => { const i = el('i', 'fx-icon ' + cls), url = "url('" + asset('popouts/' + file) + "')"; i.style.webkitMaskImage = url; i.style.maskImage = url; return i; };
  row.forEach((src, n) => {
    const a = el('a', 'mlink'), icon = el('span', 'mlink__icon'), pic1 = el('span'), words = el('span', 'mlink__words'), twin = el('span', 'mlink__b', src.textContent);
    a.href = src.getAttribute('href'); a.style.setProperty('--n', n); icon.setAttribute('aria-hidden', 'true'); twin.setAttribute('aria-hidden', 'true');
    const what = src.dataset.icon || 'glass-cubes';
    if (what === 'shirt') { const im = el('img'), p = CAT[0]; im.alt = ''; im.loading = 'lazy'; if (p) im.src = pic(p.f, 200); pic1.append(im); }
    else { const art = el('span', 'fx-art'), head = what === 'skull'; art.append(layer(head ? 'skull-head-solid.svg' : what + '-solid.png', 'fx-art__fill'), layer(head ? 'skull-head.svg' : what + '.svg', 'fx-art__line')); pic1.append(art); }
    const here = el('span', 'mlink__here'); here.setAttribute('aria-hidden', 'true');      // the dot for "you are here"
    icon.append(pic1); words.append(el('span', 'mlink__a', src.textContent), twin); a.append(icon, words, here); list.append(a);
  });
  const foot = el('div', 'menu__foot'), say = el('p'), buddy = el('img');
  say.append(el('span', '', 'Wear loudly.'), el('span', '', 'Drink responsibly.'));
  buddy.src = ASSETS ? asset('mascot-sitting-640.webp') : 'assets/mascot-sitting-640.webp?v=2'; buddy.alt = ''; buddy.loading = 'lazy'; buddy.width = 640; buddy.height = 594;
  foot.append(say, buddy); box.append(top, list, foot);
  ($('#veil') || document.body.lastElementChild).before(box);

  const outside = [$('main'), $('.foot')];
  let lastFocus = null;
  const isOpen = () => document.body.classList.contains('menu-open');
  // the panel grows out of the button: shut, it is clipped down to exactly where the button sits
  function aim() {
    const r = btn.getBoundingClientRect(), m = box.getBoundingClientRect();
    [['--mt', r.top - m.top], ['--mr', m.right - r.right], ['--mb', m.bottom - r.bottom], ['--ml', r.left - m.left]].forEach(([k, v]) => box.style.setProperty(k, Math.max(0, v).toFixed(1) + 'px'));
  }
  // "you are here": the link to the page being viewed gets a red dot and aria-current (links to a spot on a page never do)
  function markHere() {
    $$('.mlink', box).forEach(a => { const u = new URL(a.href, location.href), on = !u.hash && u.pathname === location.pathname; a.classList.toggle('is-here', on); if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
  }
  function open() {
    markHere(); lastFocus = document.activeElement; aim(); void box.offsetWidth;
    document.body.classList.add('menu-open'); box.setAttribute('aria-hidden', 'false'); btn.setAttribute('aria-expanded', 'true');
    outside.forEach(n => n && (n.inert = true)); x.focus({ preventScroll: true });
  }
  function close(refocus) {
    if (!isOpen()) return;
    aim(); document.body.classList.remove('menu-open'); box.setAttribute('aria-hidden', 'true'); btn.setAttribute('aria-expanded', 'false');
    outside.forEach(n => n && (n.inert = false));
    if (refocus !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  btn.addEventListener('click', open);
  x.addEventListener('click', () => close());
  box.addEventListener('click', e => { if (e.target.closest('a')) close(false); });      // picked a link: shut the panel and let the link do its job
  const veil = $('#veil'); if (veil) veil.addEventListener('click', () => close());
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') close();
    if (e.key !== 'Tab' || !isOpen()) return;      // while open, Tab loops inside the panel (the X, then the six links) instead of wandering onto the page behind
    const stops = [x, ...$$('.mlink', box)], i = stops.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); stops[stops.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === stops.length - 1)) { e.preventDefault(); stops[0].focus(); }
  });
  addEventListener('resize', () => { if (!isOpen()) aim(); }, { passive: true });
  aim();
  return { close, isOpen };
})();

// the shirts the hero shows, each with the panel color it floods in and the color of the words on it
const PICKS = (fromPage('picks', null) || [
  { shirt: 'trail-rated', color: '#FFC637', on: '#0E1A2B' },
  { shirt: 'tailgatin-gator-style', color: '#23B8D9', on: '#0E1A2B' },
  { shirt: 'stirred-slowly', color: '#F97020', on: '#0E1A2B' },
  { shirt: 'getting-tail', color: '#1A324E', on: '#FDFDEF' },
  { shirt: 'lets-get-flocked-up', color: '#E3212A', on: '#FDFDEF' },
  { shirt: 'storm-the-cooler', color: '#23B8D9', on: '#0E1A2B' }
]).filter(c => BY[c.shirt]);

$$('img[data-shirt]').forEach(img => { const p = BY[img.dataset.shirt]; if (p) { img.decoding = 'async'; img.src = pic(p.f, img.dataset.w || 800); } });

/* ---------- scroll shapes: one loop that rests when nothing moves ---------- */
const hero = $('#top'), topbar = $('#topbar');
const arcs = $$('[data-arc]').map(n => ({ n, last: 9, prev: $('.arc__prev', n), me: $('.arc__me', n) }));
arcs.forEach(a => { const c = getComputedStyle(a.n).getPropertyValue('--prev').trim(); if (c && a.n.parentElement) a.n.parentElement.style.setProperty('--seam', c); });      // see .fit,.last in the CSS
// the curve's shape: a slice off the top of an ellipse 1.2 screens wide, measured from the reference recording
const ARC_N = 32, ARC_G = Array.from({ length: ARC_N + 1 }, (_, i) => { const d = Math.abs(i / ARC_N - 0.5) * 2; return (1 - Math.sqrt(1 - (d / 1.2) ** 2)) / 0.4472; });
const tracked = $$('[data-p]').map(n => ({ n, last: -1 }));
const ribbon = $('#ribbonText');
let heroP = -1, ribbonLast = null, solid = null, ticking = false;
const onFrame = [];      // extra per-frame checks a page adds for itself

// the bar tab: how much paper is out of the slot
const tabFeed = $('#tab .tab__feed');
let tabT = -1;
// the fact wheel in the fit section: the stage is pinned while scrolling turns the wheel, one fact and one shirt at a time
const WHEEL_REST = 0.2;      // a short rest before the first fact turns and after the last lands, as a share of one step (the CSS height allows for it twice)
const wheel = $('#wheel');
const W = wheel && { pin: $('.wheel__pin', wheel), ring: $('.wheel__ring', wheel), arc: $('.wheel__ring path', wheel), facts: $$('.fact', wheel), shirts: $$('.wshirt', wheel), dots: $$('.wheel__dots i', wheel), tag: $('#wheelTag'), on: false, pos: -1, at: 0 };
function wheelAt(i) {
  W.at = i;
  W.facts.forEach((n, j) => n.classList.toggle('is-on', j === i));
  W.dots.forEach((n, j) => n.classList.toggle('is-on', j === i));
  W.shirts.forEach((n, j) => { n.classList.toggle('is-on', j === i); n.classList.toggle('is-prev', j < i); });
  // the name tag follows the shirt
  const p = BY[W.shirts[i].dataset.h];
  if (p && W.tag && W.tag.dataset.h !== p.h) {
    W.tag.dataset.h = p.h; W.tag.href = productUrl(p.h); W.tag.firstElementChild.textContent = p.t;
    if (W.on && W.tag.animate) W.tag.animate([{ transform: 'translateY(10px) scale(.86)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' });
  }
}
function wheelSetup() {
  if (!W) return;
  // under 520px tall (a phone held sideways) the pinned stage has no room left for the shirt, so the plain list shows (2026-10-28)
  const on = !calm.matches && CSS.supports('overflow', 'clip') && innerHeight >= 520;     // sticky needs a parent that clips without scrolling
  if (on !== W.on) { W.on = on; W.pos = -1; wheel.classList.toggle('wheel--on', on); if (!on) { wheel.style.removeProperty('--pos'); wheelAt(0); } }
  if (!on) return;
  // the spacing between facts along the arc, turned into an angle, and the dotted arc drawn to the width of the screen
  const cs = getComputedStyle(wheel), R = parseFloat(cs.getPropertyValue('--R')), gap = parseFloat(cs.getPropertyValue('--gap'));
  wheel.style.setProperty('--step', (gap / R * 180 / Math.PI).toFixed(3) + 'deg');
  const w = W.pin.clientWidth / 2, drop = R - Math.sqrt(R * R - w * w);
  W.ring.setAttribute('viewBox', -w + ' -3 ' + w * 2 + ' ' + (drop + 6)); W.ring.style.height = (drop + 6) + 'px';
  W.arc.setAttribute('d', 'M' + -w + ' ' + drop.toFixed(1) + 'A' + R + ' ' + R + ' 0 0 1 ' + w + ' ' + drop.toFixed(1));
}

// the shipping route: scrolling moves a shirt along a dashed road, the road behind it gets inked in, and each stop pops in as the shirt reaches it
const route = $('#route');
const RT = route && { box: $('.route__box', route), maps: $$('.route__map', route), shirt: $('.route__shirt', route), stops: $$('.stop', route), signs: $$('.sign', route), on: false, t: -1 };
function routeAt(t) {
  RT.t = t;
  const d = RT.len * t, p = RT.road.getPointAtLength(d), a = RT.road.getPointAtLength(Math.max(0, d - 2)), b = RT.road.getPointAtLength(Math.min(RT.len, d + 2));
  // the shirt leans the way it is heading, and stands up straight as it parks at the end
  const lean = (b.x - a.x) / (Math.hypot(b.x - a.x, b.y - a.y) || 1) * 13 * Math.min(1, (1 - t) * 12);
  const half = RT.shirt.offsetWidth / 2, x = clamp(p.x * RT.k, half, RT.box.clientWidth - half);      // where the road swings near the screen's edge, the shirt stays whole
  RT.shirt.style.transform = 'translate(-50%,-50%) translate3d(' + x.toFixed(1) + 'px,' + (p.y * RT.k).toFixed(1) + 'px,0) rotate(' + lean.toFixed(2) + 'deg)';
  // inked in: whole dashes up to where the shirt is, then nothing
  const n = Math.floor(d / (RT.dash * 2));
  RT.done.style.strokeDasharray = (RT.dash + ' ' + RT.dash + ' ').repeat(n) + Math.min(d - n * RT.dash * 2, RT.dash).toFixed(1) + ' ' + (RT.len + RT.dash);
  RT.stops.forEach((s, i) => { if (t >= RT.at[i]) s.classList.add('is-on'); });
  RT.signs.forEach((s, i) => { if (t >= RT.signAt[i] - 0.03) s.classList.add('is-on'); });      // a sign pops up just before the shirt gets to it
  // parked at the end: the shirt hops once and the last stop gives a little
  const home = t === 1 && RT.on; if (home !== RT.home) { RT.home = home; RT.shirt.classList.toggle('is-home', home); RT.stops[RT.stops.length - 1].classList.toggle('is-home', home); }
}
function routeSetup() {
  if (!RT) return;
  RT.map = RT.maps.find(m => m.getClientRects().length) || RT.maps[0];      // the wide drawing or the tall one, whichever this screen shows
  RT.road = $('.route__road', RT.map); RT.done = $('.route__done', RT.map);
  RT.done.setAttribute('d', RT.road.getAttribute('d'));
  RT.len = RT.road.getTotalLength(); RT.dash = parseFloat(getComputedStyle(RT.road).strokeDasharray) || 34;
  RT.k = RT.box.clientWidth / RT.map.viewBox.baseVal.width;      // drawing units to pixels
  RT.y0 = RT.road.getPointAtLength(0).y * RT.k; RT.y1 = RT.road.getPointAtLength(RT.len).y * RT.k;
  RT.at = RT.stops.map(s => parseFloat(getComputedStyle(s).getPropertyValue('--at')) || 0);      // where along the road each stop pops in
  // plant each sign on the road, at its share of the way along
  RT.signAt = RT.signs.map(s => parseFloat(getComputedStyle(s).getPropertyValue('--f')) || 0);
  // (kept inside the box: where the road swings past the edge of the screen, the sign stays on screen beside it)
  RT.signs.forEach((s, i) => { const p = RT.road.getPointAtLength(RT.len * RT.signAt[i]), half = s.offsetWidth / 2 + 18, bw = RT.box.clientWidth; s.style.left = clamp(p.x * RT.k, half, bw - half).toFixed(1) + 'px'; s.style.top = (p.y * RT.k).toFixed(1) + 'px'; });
  RT.on = !calm.matches; RT.t = -1;
  route.classList.toggle('route--on', RT.on); route.classList.add('route--set');
  if (!RT.on) routeAt(1);      // with reduced motion the trip is already over: every stop showing, the shirt parked at the end
}

function frame() {
  ticking = false;
  const vh = innerHeight;
  const moving = !calm.matches;

  // the hero panel shrinks as it scrolls away; the top bar becomes its own light bar
  const p = moving ? clamp(scrollY / (vh * 0.9), 0, 1) : 0;
  if (hero && (Math.abs(p - heroP) > 0.002 || (p === 1) !== (heroP === 1) || (p === 0) !== (heroP === 0))) { heroP = p; hero.style.setProperty('--p', p.toFixed(3)); }
  const s = scrollY > 24 || !hero;      // pages with no hero panel keep the light bar from the start
  if (s !== solid) { solid = s; topbar.classList.toggle('top--solid', s); }

  // the curve between sections: a smile as the line enters at the bottom, flat past halfway, a full dome near the top
  for (const a of arcs) {
    const line = a.n.parentElement.getBoundingClientRect().top;      // the middle of the curve rides this line
    if (line > vh * 1.3 || line < -vh * 0.3) continue;
    const k = moving ? clamp((vh - line) / (vh * 0.88), 0, 1) * 2 - 1 : 0.5;   // -1 smile ... 0 flat ... +1 dome
    if (Math.abs(k - a.last) > 0.004 || (Math.abs(k) === 1) !== (Math.abs(a.last) === 1)) {
      a.last = k;
      let curve = '';
      for (let i = ARC_N; i >= 0; i--) curve += 'L' + (i / ARC_N * 100).toFixed(2) + ' ' + (50 + k * 50 * ARC_G[i]).toFixed(2);
      // the section above's color is only painted below this section's top edge (y 50 in the drawing), where the curve dips in.
      // Painting it higher (from y -1, as before) laid a flat band of color over the section above and cut through its shadows.
      a.prev.setAttribute('d', 'M0 48.5L100 48.5' + curve + 'Z');      // a hair above the edge, so no seam shows
      a.me.setAttribute('d', 'M0 101L100 101' + curve + 'Z');
    }
  }
  // the fact wheel: how far the tall track has scrolled past the pinned stage sets how far the wheel has turned
  if (W && W.on) {
    const r = wheel.getBoundingClientRect(), ph = W.pin.offsetHeight;
    if (r.bottom > -ph && r.top < vh + ph) {
      const steps = W.facts.length - 1, step = (r.height - ph) / (steps + WHEEL_REST * 2);
      const pos = clamp((-r.top - step * WHEEL_REST) / step, 0, steps);
      // each fact rests level under the shirt for most of its stretch of scroll and turns only through the middle of the change
      // (the user, 2026-10-20: the fact being read was always a few degrees crooked and still moving)
      const f = Math.floor(pos), t = pos - f, u = clamp((t - .3) / .4, 0, 1), held = f + u * u * (3 - 2 * u);
      if (Math.abs(held - W.pos) > 0.001) { W.pos = held; wheel.style.setProperty('--pos', held.toFixed(4)); }
      const at = Math.round(pos);
      if (at !== W.at) wheelAt(at);
    }
  }
  // the shipping route: the shirt sets off as the road's start comes up the screen and parks near its end
  if (RT && RT.on) {
    const r = RT.box.getBoundingClientRect();
    if (r.bottom > -300 && r.top < vh + 300) {
      // it parks by the time the end of the road is as low as it can sit with the section still on screen, so the stop
      // is seen before the next section comes up (between 45% and 94% of the way down the screen)
      const tail = route.closest('section').getBoundingClientRect().bottom - (r.top + RT.y1), park = clamp(vh - tail + 40, vh * 0.45, vh * 0.94);
      const a = RT.y0 - vh * 0.7, b = RT.y1 - park, t = clamp((-r.top - a) / (b - a), 0, 1);
      if (Math.abs(t - RT.t) > 0.0004 || (t === 1) !== (RT.t === 1) || (t === 0) !== (RT.t === 0)) routeAt(t);
    }
  }
  // the bar tab: its lower edge holds at a line near the bottom of the screen, so scrolling pulls the paper out of the slot
  if (tabFeed) {
    const r = tabFeed.getBoundingClientRect();
    if (r.bottom > -100 && r.top < vh + 100) {
      // on short screens the hold line drops so the whole receipt is out by the time its top reaches the top bar
      const t = moving ? clamp((Math.max(vh * 0.84, r.height + 120) - r.top) / r.height, 0, 1) : 1;
      if (Math.abs(t - tabT) > 0.002 || (t === 1) !== (tabT === 1) || (t === 0) !== (tabT === 0)) { tabT = t; tabFeed.style.setProperty('--t', t.toFixed(4)); }
    }
  }
  // the blob behind the wheel's shirt, the leaning mascot: progress through the screen, 0 to 1
  for (const t of tracked) {
    const r = t.n.getBoundingClientRect();
    if (r.bottom < -200 || r.top > vh + 200) continue;
    const v = moving ? clamp((vh - r.top) / (vh + r.height), 0, 1) : 0.5;
    if (Math.abs(v - t.last) > 0.003) { t.last = v; t.n.style.setProperty('--p', v.toFixed(3)); }
  }
  for (const f of onFrame) f();
  // the ribbon of words slides along its wave
  if (ribbon && moving) {
    const off = (-(scrollY * 0.35) % 620).toFixed(0);
    if (off !== ribbonLast) { ribbonLast = off; ribbon.setAttribute('startOffset', off); }
  }
}
function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
addEventListener('scroll', onScroll, { passive: true });
addEventListener('resize', () => { wheelSetup(); routeSetup(); onScroll(); }, { passive: true });
calm.addEventListener('change', () => { wheelSetup(); routeSetup(); onScroll(); });
wheelSetup(); routeSetup();
if (document.fonts) document.fonts.ready.then(() => { routeSetup(); onScroll(); });      // the signs are measured again once the real font is in, or they come out too narrow and run off the edge
frame();

/* ---------- glide: mouse-wheel scrolling eases to a stop instead of jumping in steps ---------- */
const GLIDE = true;                                   // one switch to turn it off
const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
let goal = scrollY, pos = scrollY, gliding = false, mine = false;
const glideOn = () => GLIDE && finePointer.matches && !calm.matches;
function glideStep() {
  pos += (goal - pos) * 0.11;
  if (Math.abs(goal - pos) < 0.6) { pos = goal; gliding = false; }
  mine = true; scrollTo(0, pos);
  if (gliding) requestAnimationFrame(glideStep);
}
function glideTo(y) {
  const max = document.documentElement.scrollHeight - innerHeight;
  if (!gliding) pos = scrollY;
  goal = clamp(y, 0, max);
  if (!gliding) { gliding = true; requestAnimationFrame(glideStep); }
}
function goTo(node) {
  let y = node.getBoundingClientRect().top + scrollY - (node.id === 'top' ? 0 : 84);
  if (node.tagName === 'DETAILS') {      // an answer or a policy: measured without the rise-in its list may still be doing, and kept clear of the top bar
    y = 0; for (let n = node; n; n = n.offsetParent) y += n.offsetTop;
    y -= parseFloat(getComputedStyle(node).scrollMarginTop) || 84;
  }
  if (glideOn()) glideTo(y); else scrollTo({ top: y, behavior: calm.matches ? 'auto' : 'smooth' });
}
addEventListener('wheel', e => {
  if (document.body.classList.contains('menu-open')) { if (!e.target.closest || !e.target.closest('.menu')) e.preventDefault(); return; }      // and behind an open menu
  if (document.body.classList.contains('cart-open')) { if (!e.target.closest || !e.target.closest('.cart__items')) e.preventDefault(); return; }   // the page stays put behind an open cart
  if (!glideOn() || e.ctrlKey || e.metaKey) return;
  if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;   // sideways swipes belong to the shirt rail
  e.preventDefault();
  const d = e.deltaMode === 1 ? e.deltaY * 40 : e.deltaMode === 2 ? e.deltaY * innerHeight : e.deltaY;
  glideTo((gliding ? goal : scrollY) + d);
}, { passive: false });
addEventListener('scroll', () => { if (mine) { mine = false; return; } if (gliding) { gliding = false; } pos = goal = scrollY; }, { passive: true });   // scrollbar, keyboard, touch: hands off
document.addEventListener('click', e => {
  const a = e.target.closest && e.target.closest('a[href^="#"]'); if (!a || a.hasAttribute('data-sizechart')) return;      // the footer's Size chart link opens the chart instead
  const node = document.getElementById(a.getAttribute('href').slice(1)); if (!node) return;
  if (node.tagName === 'DETAILS') node.open = true;      // a jump to a policy or an answer opens it
  e.preventDefault(); goTo(node); history.replaceState(null, '', a.getAttribute('href'));
});

// while a shirt is on its way to the tab its button says so: on a slow phone the add can take a few seconds (2026-10-27).
// Returns the undo, which puts the button's words back.
function pour(btn, label = btn) {
  const was = label.textContent; label.textContent = 'Pouring...'; btn.classList.add('is-pouring'); btn.setAttribute('aria-busy', 'true');
  return () => { label.textContent = was; btn.classList.remove('is-pouring'); btn.removeAttribute('aria-busy'); };
}
// A section comes in once a tenth of it shows, or once it fills a quarter of the screen: a very tall one (the Terms of service on a
// phone is over ten screens) can never show a tenth of itself at once, and stayed invisible (2026-10-27).
const revealIO = new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting && (e.intersectionRatio >= 0.1 || e.intersectionRect.height >= innerHeight * 0.25)) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
}), { threshold: [0, 0.005, 0.01, 0.02, 0.05, 0.1], rootMargin: '0px 0px -6% 0px' });
$$('.reveal').forEach(n => revealIO.observe(n));
// a shirt's real photos, big, in a pop-up of its own; arrows and the arrow keys step through them when there is more than one.
// Used by the product page's pinned snapshot and its photo strip, and by the home page's house special.
function photoViewer(p) {
  const n = p.w.length;
  let photos = null;
  return k => {
    if (!photos) {
      photos = el('dialog', 'photos'); photos.setAttribute('aria-label', p.t + ', worn');
      const img = el('img'), x = el('button', 'zoom__x', '\u2715'), count = el('p', 'zoom__hint'), arrow = '<svg aria-hidden="true"><use href="#arrow"/></svg>';
      img.width = 720; img.height = 1080; img.decoding = 'async'; x.type = 'button'; x.setAttribute('aria-label', 'Close');
      x.addEventListener('click', () => photos.close());
      photos.append(img, x);
      photos.show = k => { photos.k = (k + n) % n; img.src = shot(p.w[photos.k]); img.alt = 'Someone out wearing the ' + p.t + ' shirt'; count.textContent = (photos.k + 1) + ' of ' + n; };
      if (n > 1) {
        const prev = el('button', 'photos__nav photos__nav--prev'), next = el('button', 'photos__nav photos__nav--next');
        prev.type = next.type = 'button'; prev.innerHTML = next.innerHTML = arrow; prev.setAttribute('aria-label', 'Previous photo'); next.setAttribute('aria-label', 'Next photo');
        prev.addEventListener('click', () => photos.show(photos.k - 1)); next.addEventListener('click', () => photos.show(photos.k + 1));
        photos.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') photos.show(photos.k - 1); if (e.key === 'ArrowRight') photos.show(photos.k + 1); });
        photos.append(count, prev, next);
      }
      photos.addEventListener('click', e => { if (e.target === photos) photos.close(); });      // a click on the dimmed page closes it
      document.body.append(photos);
    }
    photos.show(k); photos.showModal();
  };
}
/* ---------- the house special: one featured shirt, filled in from the catalog by the handle on the section ---------- */
const special = $('#special');
if (special) {
  const p = BY[special.dataset.h], flip = $('#specialFlip'), sizes = $('#specialSizes'), hint = $('#specialHint'), add = $('#specialAdd');
  if (p) {
    const url = productUrl(p.h);
    // the headline is the shirt's own line, with its last sentence picked out
    const parts = p.l.match(/[^.!?]+[.!?]+/g) || [p.l], last = parts.length > 1 ? parts.pop().trim() : '';
    const head = $('#specialH'); head.textContent = parts.join('').trim() + ' '; if (last) head.append(el('b', '', last));
    $('#specialName').textContent = p.t; $('#specialName').href = url; $('#specialView').href = url;
    $('#specialAddPrice').textContent = money(p.p);
    $$('.flip__face', special).forEach(im => { im.src = pic(im.dataset.side === 'b' ? p.b || p.f : p.f, 900); });
    // the snapshot of someone in this shirt opens big, starting on that photo
    const snap = $('.special__snap', special);
    if (snap && p.w && p.w.length) {
      const im = $('img', snap); if (!im.getAttribute('src')) im.src = shot(p.w[0]);      // on Shopify the section leaves it to the shirt's first photo
      const key = f => f.split('/').pop().split('?')[0].replace('.webp', '').replace(/^bb-wild-/, '');
      const view = photoViewer(p), at = Math.max(0, p.w.findIndex(f => key(f) === key(im.src)));
      snap.addEventListener('click', () => view(at));
    }
    else if (snap) { snap.disabled = true; if (!$('img', snap).getAttribute('src')) snap.hidden = true; }
    let pick = null;
    p.v.forEach(([title, id]) => {
      const b = el('button', '', title); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', () => { pick = [id, title]; $$('button', sizes).forEach(x => x.setAttribute('aria-pressed', x === b)); hint.textContent = 'Size ' + title; hint.classList.remove('is-nudge'); $('span', add).textContent = 'Add ' + title + ' to my tab'; });
      sizes.append(b);
    });
    add.addEventListener('click', async () => {
      if (!pick) { hint.textContent = 'Pick a size first'; hint.classList.remove('is-nudge'); void hint.offsetWidth; hint.classList.add('is-nudge'); return; }
      add.disabled = true; const done = pour(add, $('span', add));
      try { await Cart.add(pick[0], p, pick[1]); Cart.open(); } catch (e) { hint.textContent = "That didn't go through. Try again."; hint.classList.add('is-nudge'); }
      done(); add.disabled = false;
    });
  }
  // the shirt arrives with its back to you and turns around; after that, a click flips it
  const say = () => { const back = flip.classList.contains('is-back'); flip.setAttribute('aria-pressed', back); $('.flip__hint span', flip).textContent = back ? 'See the front' : 'See the back'; };
  flip.addEventListener('click', () => { flip.classList.toggle('is-back'); say(); });
  if (!calm.matches) {
    flip.classList.add('is-back');
    new IntersectionObserver((es, io) => es.forEach(e => { if (e.isIntersecting) { flip.classList.remove('is-back'); say(); io.disconnect(); } }), { threshold: 0.6 }).observe(flip);
  }
  say();
}

// "Swipe for more" under a sideways row on touch screens (the CSS shows it only where the row scrolls). It fades for good after the first
// swipe on any row, here or on another page, since by then people know the move (remembered in the browser as bb-swiped).
function swipeHint(row, cls, place) {
  const hint = el('p', 'swipe-hint ' + cls, 'Swipe for more'); hint.setAttribute('aria-hidden', 'true');
  hint.insertAdjacentHTML('beforeend', '<svg><use href="#arrow"/></svg>'); place(hint);
  let seen = false; try { seen = localStorage.getItem('bb-swiped') === '1'; } catch (e) {}
  if (seen) { hint.hidden = true; return; }
  // gone only after a real sideways swipe: the cards fill a phone's width, so a finger scrolling the page down
  // lands on them first, and a plain touch used to hide the hint before anyone saw it (found in iPhone Safari, 2026-10-28)
  let from = null;
  const gone = () => {
    $$('.swipe-hint').forEach(h => { h.classList.add('is-gone'); setTimeout(() => { h.hidden = true; }, 500); });
    try { localStorage.setItem('bb-swiped', '1'); } catch (e) {}
    row.removeEventListener('scroll', moved);
  };
  const moved = () => { if (from !== null && Math.abs(row.scrollLeft - from) > 30) gone(); };
  row.addEventListener('touchstart', () => { from = row.scrollLeft; }, { passive: true });
  row.addEventListener('scroll', moved, { passive: true });
}
// the photos in the wild pop in when their row arrives; once they have landed, rollover gets its own quicker timing
const wild = $('#wild');
// on narrow screens the photos are a row that scrolls sideways: a finger swipes it, a mouse can drag it, and the bar under it follows along
const wildRow = wild && $('.wild__pile .wild__row', wild), wildBar = wild && $('.wild__bar i', wild);
if (wildRow) {
  const bar = () => { const max = wildRow.scrollWidth - wildRow.clientWidth; if (wildBar) wildBar.style.setProperty('--s', max > 0 ? clamp(wildRow.scrollLeft / max, 0, 1).toFixed(3) : 0); };
  wildRow.addEventListener('scroll', bar, { passive: true }); addEventListener('resize', bar, { passive: true }); bar();
  const barBox = $('.wild__bar', wild); if (barBox) swipeHint(wildRow, 'wild__swipe', h => barBox.after(h));      // the hint stands in for the bar on phones
  let from = null, start = 0, moved = false;
  wildRow.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button || wildRow.scrollWidth <= wildRow.clientWidth) return; from = e.clientX; start = wildRow.scrollLeft; moved = false; });
  addEventListener('pointermove', e => { if (from === null) return; const dx = e.clientX - from; if (!moved && Math.abs(dx) > 6) { moved = true; wildRow.classList.add('drag'); } if (moved) wildRow.scrollLeft = start - dx; });
  addEventListener('pointerup', () => { if (from === null) return; from = null; wildRow.classList.remove('drag'); });
  wildRow.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);      // a drag is not a click on the photo
}
if (wild) new IntersectionObserver((es, io) => es.forEach(e => { if (e.isIntersecting) { wild.classList.add('wild--in'); setTimeout(() => wild.classList.add('wild--done'), 1300); io.disconnect(); } }), { threshold: 0.28 }).observe($('.wild__row', wild));
// the video in the wild: plays muted while it is on screen, rests when it is not, and stays paused if you pause it
const reel = $('#reel');
if (reel) {
  const box = reel.parentElement, btn = $('.reel__btn', box);
  let want = !calm.matches;      // with reduced motion it waits for the button
  const show = () => { box.classList.toggle('is-paused', reel.paused); btn.setAttribute('aria-label', reel.paused ? 'Play the video' : 'Pause the video'); };
  reel.addEventListener('play', show); reel.addEventListener('pause', show);
  btn.addEventListener('click', () => { want = reel.paused; if (want) reel.play().catch(() => {}); else reel.pause(); });
  new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { box.classList.add('is-in'); if (want) reel.play().catch(() => {}); } else reel.pause();
  }), { threshold: 0.3 }).observe(box);
  show();
}
document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

/* ---------- email sign-up in the footer ---------- */
// In this preview the address goes nowhere: it only checks the box was filled in and shows what a shopper will see.
// On Shopify the store's own customer form does the saving, and the code below has to exist there as a real discount.
const joinForm = $('#joinForm');
const JOIN_CODE = ($('[data-join-code]') || {}).dataset?.joinCode || 'BUDDY10';      // on Shopify the footer's setting
if (joinForm) joinForm.addEventListener('submit', e => {
  const input = $('#joinEmail'), note = $('#joinNote'), ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
  note.classList.toggle('is-bad', !ok);
  if (!ok) { e.preventDefault(); note.textContent = "That email doesn't look right. Give it another go."; input.focus(); return; }
  if (ON_STORE) return;      // the store's own customer form saves it; the page comes back showing the code
  e.preventDefault();
  note.textContent = "You're in. Use "; note.append(el('b', '', JOIN_CODE), ' for 10% off your first shirt.');
  joinForm.closest('.join').classList.add('is-done');
});

/* ---------- About: a shirt named in the story lifts in the picture beside it, and the other way round ---------- */
let pickTop = 10;
$$('[data-pick]').forEach(n => {
  // the shirt being lifted goes on top of the pile; when let go it stays up until it has settled back down
  const stack = (m, on) => {
    if (!m.closest('.origin__shirts')) return;
    clearTimeout(m._drop);
    if (on) m.style.zIndex = ++pickTop; else m._drop = setTimeout(() => { m.style.zIndex = ''; }, 560);
  };
  const both = on => $$('[data-pick="' + n.dataset.pick + '"]').forEach(m => { m.classList.toggle('is-lit', on); stack(m, on); });
  n.addEventListener('pointerenter', () => both(true)); n.addEventListener('pointerleave', () => both(false));
  n.addEventListener('focus', () => both(true)); n.addEventListener('blur', () => both(false));
});

/* ---------- About: the coasters turn over on a tap or a key (with a mouse, pointing turns them over) ---------- */
const mouseHover = matchMedia('(hover: hover) and (pointer: fine)');
$$('.coaster').forEach(c => c.addEventListener('click', e => {
  if (e.detail && mouseHover.matches) return;      // a mouse click: pointing already shows the back
  const on = !c.classList.contains('is-flipped');
  c.classList.toggle('is-flipped', on); c.setAttribute('aria-pressed', on);
}));

/* ---------- numbers that count up when they scroll into view (the About page's short version) ---------- */
const counts = $$('[data-count]');
if (counts.length && !calm.matches) {
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    io.unobserve(e.target);
    const n = e.target, to = +n.dataset.count, t0 = performance.now();
    if (!to) return;      // zero stays zero
    n.textContent = 0;
    (function tick(now) { const k = Math.min(1, (now - t0) / 900); n.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); })(t0);
  }), { threshold: 0.6 });
  counts.forEach(n => io.observe(n));
}

/* ---------- arrival window: 8 to 16 business days from today, weekends skipped (holidays are not, so the words say "around").
   Used by the product page's shipping band and by the "How long" answer wherever it sits ([data-eta]). ---------- */
function shipWindow() {
  const ahead = n => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
  const day = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).replace(' ', '\u00A0');      // a date never breaks across lines
  return day(ahead(8)) + ' to ' + day(ahead(16));
}
$$('[data-eta]').forEach(n => { n.textContent = ' Order today and it should be at your door around'; n.append(el('b', 'eta-date', shipWindow())); });      // the dates in the same dark tag as the shipping cards
$$('[data-eta-card]').forEach(n => { n.textContent = 'Order today, at your door around'; n.append(el('b', 'eta-date', shipWindow())); });      // the home page road's last card

/* ---------- contact: a short note. The topic can come in the link (?topic=photo from "Send a photo", ?topic=return from the
   returns answer). An order number is asked for only when it helps, and "My photo" says plainly that a form can't carry a picture.
   In this preview nothing is sent anywhere; on Shopify this becomes the store's own contact form. ---------- */
const note = $('#form');
if (note) {
  const fld = k => $('[data-f="' + k + '"]', note), topics = $$('[data-f="topic"]', note), orderField = $('#orderField'), shirtField = $('#shirtField'), shareField = $('#shareField'), tip = $('#noteTip'), msg = $('#noteMsg');
  // "My photo" asks which shirt, so the photo can go on the right page; a link from a shirt's page fills it in (?shirt=handle)
  const shirtPick = $('select', shirtField);
  CAT.forEach(x => { const o = el('option', '', x.t); o.value = x.h; shirtPick.append(o); });
  shirtPick.value = BY[new URLSearchParams(location.search).get('shirt')] ? new URLSearchParams(location.search).get('shirt') : '';
  const TIPS = { photo: "A form can't carry pictures. Send this and I'll write back, then just reply with your photo.", idea: 'Got a design in mind? Describe it. Every shirt here started as somebody\'s bad idea.' };
  const pick = () => {
    const t = (topics.find(r => r.checked) || topics[0]).value;
    orderField.hidden = !(t === 'order' || t === 'return'); shirtField.hidden = t !== 'photo'; if (shareField) shareField.hidden = t !== 'photo';
    tip.hidden = !TIPS[t]; tip.textContent = TIPS[t] || '';
  };
  const asked = new URLSearchParams(location.search).get('topic'), start = topics.find(r => r.value === asked);
  if (start) start.checked = true;
  topics.forEach(r => r.addEventListener('change', pick)); pick();
  // a tag elsewhere on the page (data-topic, e.g. "A return" in the quick answers) picks that topic and goes back up to the form
  $$('[data-topic]').forEach(b => b.addEventListener('click', () => {
    const r = topics.find(x => x.value === b.dataset.topic); if (!r) return;
    r.checked = true; pick();
    const y = note.getBoundingClientRect().top + scrollY - 110;
    if (glideOn()) glideTo(y); else scrollTo({ top: y, behavior: calm.matches ? 'auto' : 'smooth' });
    r.focus({ preventScroll: true });
  }));
  note.addEventListener('submit', e => {
    const f = { name: fld('name'), email: fld('email'), body: fld('body') }, bad = [];
    if (!f.name.value.trim()) bad.push(f.name);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.value.trim())) bad.push(f.email);
    if (!f.body.value.trim()) bad.push(f.body);
    [f.name, f.email, f.body].forEach(n => n.setAttribute('aria-invalid', bad.includes(n)));
    msg.classList.toggle('is-bad', bad.length > 0);
    if (bad.length) e.preventDefault();
    if (bad.length) { msg.textContent = bad[0] === f.email && f.email.value.trim() ? "That email doesn't look right." : 'Fill in the empty ones and send it again.'; bad[0].focus(); return; }
    // one send only: a second click while the first is on its way does nothing
    const send = $('button[type="submit"]', note);
    if (note.dataset.sending) { e.preventDefault(); return; }
    note.dataset.sending = '1'; send.disabled = true; $('span', send).textContent = 'Sending...';
    if (ON_STORE) return;      // the store's own contact form sends it; the page comes back with the thank-you (see the contact section)
    e.preventDefault();
    const done = el('div', 'note__done');
    done.append(el('p', 'note__h', 'Got it, ' + f.name.value.trim().split(' ')[0] + '.'), el('p', '', "It's on my desk. I'll write back to " + f.email.value.trim() + '.'));
    // a next step instead of a dead end, and the skeleton raises a glass
    const more = el('a', 'go'); more.href = ON_STORE ? STORE + '/collections/every-damn-shirt' : 'shirts.html';
    more.append(el('span', '', "See what's on tap")); more.insertAdjacentHTML('beforeend', '<i><svg aria-hidden="true"><use href="#arrow"/></svg></i>'); done.append(more);
    note.classList.add('is-sent'); note.append(done); done.tabIndex = -1; done.focus();
    const say = $('.hello__buddy .bubble'); if (say) { say.textContent = 'Cheers.'; say.classList.remove('is-new'); void say.offsetWidth; say.classList.add('is-new'); }
  });
}

/* the fan of shirts at the bottom of a page: each one carries its name tag, shown when a mouse points at it */
$$('.fan a').forEach(a => { const t = el('span', 'fan__tag', a.getAttribute('aria-label')); t.setAttribute('aria-hidden', 'true'); a.append(t); });

/* ---------- size chart: one pop-up, opened by any "Size chart" button ---------- */
// The numbers are the print shop's own chart for this shirt (sent by the owner, 2026-10-13): the shirt laid flat, in inches.
// Never change them by guesswork. On Shopify they become settings.
const SIZE_COLS = ['Chest', 'Length', 'Shoulder', 'Sleeve'];
const SIZE_ROWS = {
  XS: ['20', '28\u00BD', '17\u00BE', '8\u00BC'], S: ['21', '29', '18\u00BC', '8\u00BD'], M: ['22', '29\u00BD', '18\u00BE', '8\u00BE'], L: ['23', '30', '19\u00BC', '9'],
  XL: ['24\u00BD', '30\u00BE', '20', '9\u00BC'], '2XL': ['26\u00BE', '32', '21\u215B', '9\u215D'], '3XL': ['29', '33', '22\u00BC', '10'], '4XL': ['31\u00BC', '34', '23\u215C', '10\u215C']
};
const SIZE_NOTE = 'Inches, with the shirt laid flat. Chest is straight across, just under the arms, so double it for all the way around. Length is the front. Each shirt is made by hand, so yours can be off by up to an inch.';
const SIZE_FIT = 'Regular fit, true to size. Not sure? Lay a shirt you love flat, measure it the same way, and match it to the chart.';
const SIZE_FABRIC = '88% polyester, 12% spandex. Machine wash cold, inside out. Drip dry. No bleach.';
let chart = null;
function sizeChart(picked) {
  if (!chart) {
    chart = el('dialog', 'chart'); chart.setAttribute('aria-labelledby', 'chartH');
    const box = el('div', 'chart__in'), top = el('div', 'chart__top'), h = el('h2', '', 'Size chart'), x = el('button', 'chart__x', '\u2715');
    h.id = 'chartH'; x.type = 'button'; x.setAttribute('aria-label', 'Close the size chart'); x.addEventListener('click', () => chart.close());
    top.append(h, x);
    const table = el('table'), head = el('tr'), body = el('tbody');
    head.append(el('th', '', 'Size'), ...SIZE_COLS.map(c => el('th', '', c)));
    Object.entries(SIZE_ROWS).forEach(([size, nums]) => { const tr = el('tr'); tr.dataset.size = size; tr.append(el('td', '', size), ...SIZE_COLS.map((c, i) => el('td', '', nums[i] != null ? nums[i] + '"' : ''))); body.append(tr); });
    const thead = el('thead'); thead.append(head); table.append(thead, body);
    const filled = Object.values(SIZE_ROWS).some(r => r.length);
    box.append(top, el('p', 'chart__lead', SIZE_FIT), table, el('p', 'chart__note', filled ? SIZE_NOTE : 'The measurements are not in yet.'));
    if (filled) box.append(el('p', 'chart__note chart__note--fabric', SIZE_FABRIC));
    chart.append(box); document.body.append(chart);
    chart.addEventListener('click', e => { if (e.target === chart) chart.close(); });      // a click on the dimmed page closes it
  }
  $$('tbody tr', chart).forEach(tr => tr.classList.toggle('is-on', tr.dataset.size === picked));
  chart.showModal();
}
document.addEventListener('click', e => {
  const b = e.target.closest && e.target.closest('[data-sizechart]'); if (!b) return;
  if (b.tagName === 'A') e.preventDefault();      // the footer link: open the chart here, the link is only for when there is no script
  const near = b.closest('.special__pick'), on = near && $('[aria-pressed="true"]', near);      // light up the picked size when the button sits beside a size row
  sizeChart(on ? on.textContent.trim() : null);
});

/* ---------- cart ---------- */
const Cart = (() => {
  const root = $('#cart'), list = $('#cartItems'), count = $('#cartCount'), openBtn = $('#cartOpen');
  const total = $('#cartTotal'), ship = $('#cartShip'), meter = $('#meter'), out = $('#checkout');
  const outside = [$('main'), topbar, $('.foot')];
  let items = [], lastFocus = null;

  const save = () => { try { sessionStorage.setItem('bb-cart', JSON.stringify(items)); } catch (e) {} };
  const sum = () => items.reduce((s, i) => s + i.price * i.qty, 0);

  async function api(path, body) {
    const res = await fetch(path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart ' + res.status);
    return res.json();
  }
  async function sync() {
    const c = await api('/cart.js');
    items = c.items.map(i => ({ id: i.variant_id, key: i.key, t: i.product_title, size: i.variant_title, qty: i.quantity, price: i.final_price / 100, img: i.image }));
  }
  // three small shirt cards under a marker line, each opening its shirt (a size has to be picked there)
  let starters = null;
  function roundBox(title, three) {
    const box = el('div', 'round'), row = el('div', 'round__row');
    three.forEach(x => { const a = el('a', 'round__shirt'); a.href = productUrl(x.h); const im = el('img'); im.src = pic(x.f, 240); im.alt = ''; im.width = 120; im.height = 120; im.loading = 'lazy'; a.append(im, el('span', '', x.t)); row.append(a); });
    box.append(el('p', 'round__h', title), row);
    return box;
  }
  function render() {
    list.textContent = '';
    root.classList.toggle('cart--empty', !items.length);
    if (!items.length) {      // an empty tab still points somewhere: every shirt
      const go = el('a', 'go go--ink cart__go'); go.href = ON_STORE ? '/collections/every-damn-shirt' : 'shirts.html';
      go.innerHTML = '<span>See what\'s on tap</span><i><svg aria-hidden="true"><use href="#arrow"/></svg></i>';
      list.append(el('p', 'cart__empty', "Your tab's empty. Go pick a loud one."), go);
      // and three shirts to start with (the user, 2026-10-27): one of each kind where it can, never opening on a military shirt,
      // dealt fresh on each page so a regular sees different ones
      if (CAT.length) {
        if (!starters) {
          const deck = CAT.slice().sort(() => Math.random() - .5), seen = new Set();
          starters = deck.filter(x => { const k = (x.c || [])[0]; if (seen.has(k)) return false; seen.add(k); return true; }).concat(deck).filter((x, i, a) => a.indexOf(x) === i).slice(0, 3);
          const lead = starters.findIndex(x => !(x.c || []).includes('military')); if (lead > 0) starters.unshift(starters.splice(lead, 1)[0]);
        }
        list.append(roundBox('Start with one of these:', starters));
      }
    }
    items.forEach(it => {
      const row = el('div', 'item');
      const im = el('img'); im.alt = ''; im.width = 72; im.height = 72; im.src = pic(it.img, 160);
      const qty = el('span', 'qty');
      const minus = el('button', '', '-'); minus.type = 'button'; minus.setAttribute('aria-label', 'One fewer ' + it.t);
      const plus = el('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'One more ' + it.t);
      minus.addEventListener('click', () => change(it, it.qty - 1));
      plus.addEventListener('click', () => change(it, it.qty + 1));
      qty.append(minus, el('output', '', it.qty), plus);
      row.append(im, el('b', '', it.t), el('span', '', money(it.price * it.qty)), el('small', '', 'Size ' + it.size), qty);
      list.append(row);
    });
    const s = sum();
    // under the $75 line, three more shirts to make it a round: picked like the product page's Next round, other kinds mixed in,
    // never opening on a military shirt. Each opens its shirt (a size has to be picked there).
    // Past the line, shipping is already free and the drawer sat half empty, so the three stay as "One for the road:" (the user, 2026-10-27).
    if (items.length && CAT.length) {
      const inTab = new Set(items.map(i => i.t)), base = CAT.find(x => x.t === items[0].t) || CAT[0];
      const rest = CAT.filter(x => !inTab.has(x.t)), near = rest.filter(x => base.c && x.c.some(c => base.c.includes(c))), far = rest.filter(x => !near.includes(x)), mix = [];
      while (near.length || far.length) { if (far.length) mix.push(far.shift()); if (near.length) mix.push(near.shift()); }
      const three = mix.slice(0, 3), lead = three.findIndex(x => !x.c.includes('military')); if (lead > 0) three.unshift(three.splice(lead, 1)[0]);
      if (three.length) list.append(roundBox(s < FREE_AT ? 'Make it a round:' : 'One for the road:', three));
    }
    total.textContent = money(s);
    meter.style.setProperty('--m', clamp(s / FREE_AT, 0, 1).toFixed(3));
    // said in shirts, not cents: every shirt is $49.99, so one more always clears the $75 line
    ship.textContent = !items.length ? 'Free US shipping over $75. Two shirts get you there.' : s >= FREE_AT ? "Shipping's on us." : "One more shirt and shipping's on us.";
    count.textContent = items.reduce((n, i) => n + i.qty, 0);
    openBtn.classList.toggle('has-items', items.length > 0);      // the count's circle turns yellow once something is on the tab
    out.disabled = !items.length;
    if (document.body.classList.contains('cart-open')) requestAnimationFrame(fitPeek);      // the last shirt taken off while it's open
    // the product page's "Next round" line follows the tab, so it is always true about the $75 line
    const next = $('#nextLine');
    if (next) next.textContent = !items.length ? "Grab a second one and shipping's on us." : s >= FREE_AT ? "Shipping's already on us. Go wild." : "One more and shipping's on us.";
  }
  async function add(id, p, size) {
    if (ON_STORE) { await api('/cart/add.js', { items: [{ id, quantity: 1 }] }); await sync(); }
    else { const hit = items.find(i => i.id === id); if (hit) hit.qty++; else items.push({ id, t: p.t, size, qty: 1, price: +p.p, img: p.f }); save(); }
    render();
    openBtn.classList.remove('bump'); void openBtn.offsetWidth; openBtn.classList.add('bump');
  }
  async function change(it, qty) {
    try {
      if (ON_STORE) { await api('/cart/change.js', { id: it.key, quantity: Math.max(0, qty) }); await sync(); }
      else { it.qty = qty; items = items.filter(i => i.qty > 0); save(); }
    } catch (e) { ship.textContent = "That didn't go through. Try again."; return; }
    render();
  }
  function open() { lastFocus = document.activeElement; document.body.classList.add('cart-open'); root.setAttribute('aria-hidden', 'false'); outside.forEach(n => n && (n.inert = true)); $('#cartClose').focus(); requestAnimationFrame(fitPeek); }
  // the skeleton peeks up over the bar top (empty or not, 2026-10-27); where he would cover the shirts or the picks, he sits it out
  // (measured from where he ends up, not mid-animation: his visible part is 79% of his height above the bar top)
  // A little short of room, he gets smaller (down to 96px wide); shorter still, he sits it out.
  function fitPeek() {
    root.classList.remove('cart--tight');
    const r = $('.round', root), b = $('.cart__bust', root), p = $('.cart__peek', root);
    if (!p) return;
    p.style.removeProperty('--w');
    const above = r || list.lastElementChild;      // the lowest thing he must not cover (the picks, else the last shirt)
    if (!above || !b) return;
    const room = p.getBoundingClientRect().top - above.getBoundingClientRect().bottom - 10, w = room / (1.367 * .79);
    if (w < b.offsetWidth) { if (w >= 96) p.style.setProperty('--w', Math.floor(w) + 'px'); else root.classList.add('cart--tight'); }
  }
  addEventListener('resize', () => { if (document.body.classList.contains('cart-open')) fitPeek(); });
  function close() { document.body.classList.remove('cart-open'); root.setAttribute('aria-hidden', 'true'); outside.forEach(n => n && (n.inert = false)); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  openBtn.addEventListener('click', open);
  $('#cartClose').addEventListener('click', close);
  $('#veil').addEventListener('click', close);
  $$('[data-open-tab]').forEach(b => b.addEventListener('click', open));      // e.g. "Open your tab" on the cart page
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.body.classList.contains('cart-open')) close(); });
  out.addEventListener('click', () => { if (items.length) location.href = ON_STORE ? '/checkout' : STORE + '/cart/' + items.map(i => i.id + ':' + i.qty).join(','); });

  if (ON_STORE) sync().then(render).catch(render);
  // the cart page (/cart) is just the tab, opened; with nothing on it the page shows no "Open your tab" and stays shut
  if (document.body.classList.contains('page-cart')) { if ($('[data-open-tab]')) setTimeout(open, 400); }
  else { try { items = JSON.parse(sessionStorage.getItem('bb-cart')) || []; } catch (e) { items = []; } render(); }
  return { add, open };
})();

/* ---------- product page: one shirt, filled in from the catalog by ?h=handle. On Shopify, Liquid renders all of this. ---------- */
const pdp = $('#pdp');
const PDP = pdp ? (BY[pdp.dataset.h] || BY[new URLSearchParams(location.search).get('h')] || BY['tailgatin-gator-style'] || CAT[0]) : null;      // on Shopify the section names its shirt (data-h)
if (PDP) {
  const p = PDP, panel = $('#pdpPanel'), sizes = $('#pdpSizes'), hint = $('#pdpHint'), add = $('#pdpAdd');
  if (!ON_STORE) document.title = p.t + ' | Booze Buddies';      // on the store the page already has the better title (shirt name first, then its search title)
  $('#pdpLine').textContent = p.l;
  revealIO.observe($('.pdp__under'));      // the pitch line's underline draws itself in once the line has risen
  // the name is set one letter to a span so the letters can tumble in on load; screen readers get it whole
  const nameEl = $('#pdpName'); nameEl.setAttribute('aria-label', p.t); nameEl.textContent = '';      // on Shopify the plain name is there first, for search engines and no-script
  let letters = 0;
  p.t.split(' ').forEach(w => {
    const word = el('span', 'pdp__word'); word.setAttribute('aria-hidden', 'true');
    [...w].forEach(ch => { const l = el('span', 'pdp__ch', ch); l.style.setProperty('--n', letters); l.style.setProperty('--r', ((letters * 37) % 44 - 22) + 'deg'); letters++; word.append(l); });
    nameEl.append(word, ' ');
  });
  // whiskey glasses hanging in the air behind the shirt, never over it. Big ones read as near and small ones as far.
  // Each drifts on its own clock and leans away from the mouse by its depth. The skull stays out of it: he belongs to "Put it on him".
  // The five places, as: left %, top %, width (% of the panel's width), tilt, depth
  const SPOTS = [[3, 5, 20, -13, 24], [78, 3, 15, 12, 16], [84, 50, 11, 17, 10], [72, 69, 22, -9, 30], [8, 66, 12, -15, 14]];
  // every shirt gets its own deal of the six glasses: which glass lands where depends on the shirt's place in the catalog
  const POURS = ['glass-cubes', 'glass-ball', 'glass-rocks', 'glass-twist', 'glass-square', 'glass-tulip'], deal = Math.max(0, CAT.indexOf(p));
  const layer = (file, cls) => { const i = el('i', 'fx-icon ' + cls), url = "url('" + asset('popouts/' + file) + "')"; i.style.webkitMaskImage = url; i.style.maskImage = url; return i; };
  const snapped = !!(p.w && p.w.length);      // a shirt with real photos shows them beside its name (see "the shirt's photos, fanned" below)
  // a shirt can carry its own art ("Floating art" on the product in the admin, `a` in the catalog): picture 1 takes the first
  // spot, picture 2 the second, and so on; a spot with no picture keeps its glass
  const own = p.a || [];
  SPOTS.forEach(([x, y, w, rot, depth], i) => {
    const f = el('span', 'float'), inner = el('span', 'fx-art'), glass = POURS[(deal * 5 + i) % 6];
    if (own[i]) { const img = el('img'); img.src = own[i]; img.alt = ''; img.decoding = 'async'; inner.append(img); f.classList.add('float--own'); }
    else inner.append(layer(glass + '-solid.png', 'fx-art__fill'), layer(glass + '.svg', 'fx-art__line'));
    f.style.cssText = '--x:' + x + '%;--y:' + y + '%;--w:' + w + 'cqw;--rot:' + (deal % 2 ? -rot : rot) + 'deg;--d:' + depth +
      ';--t:' + (5.5 + ((i * 1.7 + depth) % 4)) + 's;--k:' + i + ';--dx:' + (i % 2 ? 5 : -6) + '%;--dy:' + (7 + (i % 3) * 2) + '%;--dr:' + (i % 2 ? -6 : 7) + 'deg;--fx:' + (50 - x - w / 2) + 'cqw;--fy:' + (45 - y) + 'cqh';
    f.append(inner); $('#pdpFloats').append(f);
  });
  let lean = null;
  panel.addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse' || calm.matches || lean) return;
    lean = requestAnimationFrame(() => { lean = null; const r = panel.getBoundingClientRect(); panel.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(2)); panel.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(2)); });
  });
  panel.addEventListener('pointerleave', () => { panel.style.setProperty('--mx', 0); panel.style.setProperty('--my', 0); });
  const parked = $('#trailShirt'); if (parked) parked.src = pic(p.f, 400);      // this shirt, parked at the end of the shipping road
  // the shipping band's last card: the real arrival window (see shipWindow)
  const eta = $('#shipEta'); if (eta) { eta.textContent = 'Order today, at your door around'; eta.append(el('b', 'eta-date', shipWindow())); }      // the dates sit in a dark tag of their own so they stand out on the red
  $('#pdpPrice').textContent = money(p.p); $('#pdpAddPrice').textContent = money(p.p);
  const front = $('#pdpFront'), back = $('#pdpBack');
  front.src = pic(p.f, 1000); front.alt = p.fa || p.t + ', front'; back.src = pic(p.b || p.f, 1000); back.alt = p.ba || p.t + ', back';
  // the load animation starts once the shirt's picture is ready to show, or after a short wait if it is slow
  let played = false; const play = () => { if (played) return; played = true; requestAnimationFrame(() => pdp.classList.add('pdp--in')); };
  front.decode().then(play, play); setTimeout(play, 1400);
  $('#pdpDesc').replaceChildren();      // on the store the description is already in the page for search engines; the script redraws it
  (p.d || []).forEach(t => $('#pdpDesc').append(el('p', '', t)));
  if (p.e) $('#pdpEnd').textContent = p.e; else $('#pdpEnd').remove();
  // on phones the story shows its first paragraph and a button for the rest; the sign-off always shows
  const desc = $('#pdpDesc');
  if (desc.children.length > 1) {
    const more = el('button', 'pdp__more'); more.type = 'button'; more.setAttribute('aria-expanded', 'false'); more.setAttribute('aria-controls', 'pdpDesc');
    more.append(el('span', '', 'Read the rest')); more.insertAdjacentHTML('beforeend', '<svg aria-hidden="true"><use href="#arrow"/></svg>');
    desc.classList.add('is-short'); desc.after(more);
    more.addEventListener('click', () => { const open = desc.classList.toggle('is-short') === false; more.setAttribute('aria-expanded', open); $('span', more).textContent = open ? 'Show less' : 'Read the rest'; });
  }
  // the panel takes the loud color that stands off most from this shirt
  stageColor(p.f, s => { if (s) { panel.style.setProperty('--stage', s.c); panel.style.setProperty('--stage-on', s.on); } });

  // sizes and add to cart, shared by the main button and the bar that follows you down the page
  const bar = $('#buybar'), barAdd = $('#barAdd'), barMeta = $('#barMeta');
  let pick = null;
  const nudge = msg => { hint.textContent = msg; hint.classList.remove('is-nudge'); void hint.offsetWidth; hint.classList.add('is-nudge'); };
  const barState = () => { barMeta.textContent = money(p.p) + (pick ? ' · Size ' + pick[1] : ' · Pick a size'); barAdd.textContent = pick ? 'Add ' + pick[1] + ' to my tab' : 'Pick a size'; $('span', add).textContent = pick ? 'Add ' + pick[1] + ' to my tab' : 'Add to my tab'; };
  p.v.forEach(([title, id]) => {
    const b = el('button', '', title); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', () => { pick = [id, title]; $$('button', sizes).forEach(x => x.setAttribute('aria-pressed', x === b)); hint.textContent = 'Size ' + title; hint.classList.remove('is-nudge'); barState(); });
    sizes.append(b);
  });
  const addIt = async btn => {
    if (!pick) return nudge('Pick a size first');
    btn.disabled = true; const done = pour(btn, $('span', btn) || btn);
    try { await Cart.add(pick[0], p, pick[1]); Cart.open(); } catch (e) { nudge("That didn't go through. Try again."); }
    done(); btn.disabled = false;
  };
  add.addEventListener('click', () => addIt(add));
  $('#barImg').src = pic(p.f, 160); $('#barName').textContent = p.t; barState();
  // the bar shows once the main button has scrolled away above. It used to show too while the button was still below a short screen,
  // but in iPhone Safari (about 714px tall) that was nearly every phone, and the bar sat on the size buttons as the page opened (2026-10-28)
  let barOn = false;
  // ...and steps aside while "Next round" is on screen, where it would sit on top of the other shirts' cards
  // and once the footer comes up, where it would cover the email sign-up and the footer links
  const later = $('#shirts'), foot = $('.foot');
  onFrame.push(() => { const r = add.getBoundingClientRect(), on = r.bottom < 0 && !(later && (lr => lr.top < innerHeight * .8 && lr.bottom > innerHeight * .2)(later.getBoundingClientRect())) && !(foot && foot.getBoundingClientRect().top < innerHeight * .9); if (on === barOn) return; barOn = on; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on); barAdd.tabIndex = on ? 0 : -1; });
  onScroll(); setTimeout(onScroll, 1800);      // check once now and again after the load animation, before any scrolling
  barAdd.addEventListener('click', () => {
    if (pick) return addIt(barAdd);
    const y = sizes.getBoundingClientRect().top + scrollY - innerHeight * 0.4;      // no size yet: go back up to the sizes
    if (glideOn()) glideTo(y); else scrollTo({ top: y, behavior: calm.matches ? 'auto' : 'smooth' });
    nudge('Pick a size first');
  });

  // the fit facts point at this shirt: pointing at a fact or its dot, focusing a fact, or tapping either lights the pair
  const fitPic = $('#fitShirt');
  if (fitPic) {
    fitPic.src = pic(p.f, 1000); fitPic.alt = p.t + ', front, with its four features marked';      // the same size as the panel's, so the browser reuses it instead of downloading it twice
    const grid = $('.fitmap__grid'), pairs = $$('[data-dot]', grid), light = k => { grid.classList.toggle('has-on', !!k); pairs.forEach(n => n.classList.toggle('is-on', n.dataset.dot === k)); };
    // until someone points at or taps one, the facts light up in turn, slowly, while the section is on screen; then it is theirs
    let tour = null, tourK = 0, toured = false, focusAt = 0;
    const tourOrder = $$('.fitmap__fact', grid).map(f => f.dataset.dot);      // in the order the facts are written, not by dot number
    const tourStop = () => { clearInterval(tour); tour = null; };
    const tourEnd = () => { if (toured) return; toured = true; tourStop(); };
    if (!calm.matches) new IntersectionObserver(es => es.forEach(e => {
      if (toured) return;
      if (e.isIntersecting && !tour) { const step = () => { tourK = tourK % tourOrder.length + 1; light(tourOrder[tourK - 1]); }; setTimeout(() => { if (!toured && !tour) { step(); tour = setInterval(step, 4000); } }, 900); }
      else if (!e.isIntersecting) { tourStop(); light(null); }
    }), { threshold: 0.45 }).observe(grid);
    pairs.forEach(n => {
      n.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { tourEnd(); light(n.dataset.dot); } });
      n.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') light(null); });
      n.addEventListener('click', e => { if (e.pointerType !== 'mouse') { const was = n.classList.contains('is-on') && toured && Date.now() - focusAt > 400; tourEnd(); light(was ? null : n.dataset.dot); } });      // a tap also focuses: that first tap lights it rather than turning it straight off
      n.addEventListener('focus', () => { focusAt = Date.now(); tourEnd(); light(n.dataset.dot); }); n.addEventListener('blur', () => light(null));
    });
  }

  // turn the shirt over
  const flip = $('#pdpFlip');
  // "On a body": the print shop's pictures of this shirt on a model, in place of the flat shirt, for how it hangs.
  // While it's on, the turn button steps through front, back and side.
  const bodyBtn = $('#pdpBodyBtn'), bodyImg = $('#pdpBody'), MODEL = p.m || [], VIEWS = MODEL.map(u => { const n = u.split('?')[0].split('/').pop(); return /back/i.test(n) ? 'back' : /front/i.test(n) ? 'front' : 'side'; });      // named from the picture itself, in case a shirt is missing one
  let view = 0;
  const label = () => {
    if (panel.classList.contains('is-body')) { $('span', flip).textContent = 'See the ' + VIEWS[(view + 1) % MODEL.length]; flip.setAttribute('aria-pressed', 'false'); return; }
    const b = panel.classList.contains('is-back'); flip.setAttribute('aria-pressed', b); $('span', flip).textContent = b ? 'See the front' : 'See the back';
  };
  // two layers that take turns, so a new angle only shows once it has loaded, and crossfades in with a small turn
  const layers = bodyImg ? [bodyImg, bodyImg.cloneNode()] : [];
  if (bodyImg) { layers[1].removeAttribute('id'); bodyImg.after(layers[1]); bodyImg.classList.add('is-on'); }
  let front_ = 0;
  const showBody = (k, instant) => {
    const dir = k > view ? 1 : -1; view = k; label();
    const next = layers[1 - front_], cur = layers[front_];
    next.src = pic(MODEL[k], 1000); next.alt = (p.ma && p.ma[k]) || p.t + ' on a model, ' + VIEWS[k];
    const swap = () => {
      if (view !== k) return;      // a newer click already moved on
      next.style.setProperty('--dir', dir); cur.style.setProperty('--dir', -dir);
      if (instant) { next.style.transition = cur.style.transition = 'none'; }      // coming from the flat shirt: the box fades, not the picture inside it
      next.classList.add('is-on'); cur.classList.remove('is-on'); front_ = 1 - front_;
      if (instant) { void next.offsetWidth; next.style.transition = cur.style.transition = ''; }
    };
    return (next.decode ? next.decode() : Promise.resolve()).then(swap, swap);
  };
  const setFlip = on => { panel.classList.toggle('is-back', on); label(); };
  flip.addEventListener('click', () => { if (panel.classList.contains('is-body')) showBody((view + 1) % MODEL.length); else setFlip(!panel.classList.contains('is-back')); });
  if (bodyBtn && MODEL.length) {
    bodyBtn.hidden = false;
    bodyBtn.addEventListener('click', () => {
      const on = !panel.classList.contains('is-body');
      const flipTo = () => { panel.classList.toggle('is-body', on); bodyBtn.setAttribute('aria-pressed', on); $('span', bodyBtn).textContent = on ? 'Flat shirt' : 'On a body'; label(); };
      if (on) {
        // load the model first, then hand over: the flat shirt steps back, the model steps in
        showBody(Math.max(0, panel.classList.contains('is-back') ? VIEWS.indexOf('back') : 0), true).then(flipTo, flipTo);
        MODEL.forEach(u => { new Image().src = pic(u, 1000); });      // the other angles, ready for the turn button
      } else flipTo();
    });
  }

  // look closer: the print up close in a pop-up, on whichever side is showing. With a mouse the picture follows the pointer;
  // on touch you drag it around. The store's pictures are 1500px, about three times the size of the shirt in the panel.
  let zoom = null;
  const openZoom = () => {
    if (!zoom) {
      zoom = el('dialog', 'zoom'); zoom.setAttribute('aria-label', p.t + ', up close');
      const pane = el('div', 'zoom__pane'), img = el('img'), x = el('button', 'zoom__x', '\u2715'), side = el('button', 'tool zoom__side'),
        hint = el('p', 'zoom__hint', mouseHover.matches ? 'Move around to look closer' : 'Drag to look around');
      pane.tabIndex = 0; img.decoding = 'async'; x.type = side.type = 'button'; x.setAttribute('aria-label', 'Close');
      side.append(el('span')); pane.append(img); zoom.append(pane, hint, x, side); document.body.append(zoom);
      const center = () => { pane.scrollLeft = (pane.scrollWidth - pane.clientWidth) / 2; pane.scrollTop = (pane.scrollHeight - pane.clientHeight) * 0.35; };
      zoom.setSide = b => {
        zoom.back = b; img.src = pic(b ? p.b || p.f : p.f, 1500); img.alt = ((b ? p.ba : p.fa) || p.t + (b ? ', back' : ', front')) + ', up close';
        $('span', side).textContent = b ? 'See the front' : 'See the back';
        if (img.complete) center(); else img.onload = center;
      };
      side.addEventListener('click', () => zoom.setSide(!zoom.back));
      x.addEventListener('click', () => zoom.close());
      zoom.addEventListener('click', e => { if (e.target === zoom) zoom.close(); });      // a click on the dimmed page closes it
      // the mouse steers: the spot under the pointer slides into view, eased so it glides instead of jumping
      let tx = 0, ty = 0, go = null;
      const step = () => {
        const ex = tx * (pane.scrollWidth - pane.clientWidth), ey = ty * (pane.scrollHeight - pane.clientHeight), k = calm.matches ? 1 : 0.16;
        pane.scrollLeft += (ex - pane.scrollLeft) * k; pane.scrollTop += (ey - pane.scrollTop) * k;
        go = Math.abs(ex - pane.scrollLeft) + Math.abs(ey - pane.scrollTop) > 1 ? requestAnimationFrame(step) : null;
      };
      pane.addEventListener('pointermove', e => {
        if (e.pointerType !== 'mouse') return;
        const r = pane.getBoundingClientRect(); tx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)); ty = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
        if (!go) go = requestAnimationFrame(step);
      });
      zoom.addEventListener('close', () => { if (go) cancelAnimationFrame(go); go = null; });
    }
    const look = getComputedStyle(panel); zoom.style.backgroundColor = look.backgroundColor; zoom.style.backgroundImage = look.backgroundImage;      // the panel's own color and spotlight
    zoom.setSide(panel.classList.contains('is-body') ? VIEWS[view] === 'back' : panel.classList.contains('is-back'));      // on a body, the close-up is still the flat print, front or back
    zoom.showModal();
  };
  $('#pdpZoom').addEventListener('click', openZoom);
  $('.pdp__shirt', panel).addEventListener('click', openZoom);
  $('.pdp__body', panel)?.addEventListener('click', openZoom);

  // real photos of this shirt beside an ask for more; each opens big. With none, the section shrinks to the ask.
  // "Send a photo" takes this shirt along to the contact form.
  $$('#wild a[href*="/pages/contact"]').forEach(a => { const u = new URL(a.href); u.searchParams.set('shirt', p.h); a.href = u.href; });
  const row = $('#pdpWild'), tilt = [-4, 3, -2.5], drop = [14, -10, 20], drift = [40, -46, 34];
  let openPhoto = () => {};      // set once the photo pop-up below is ready
  if (p.w && p.w.length) p.w.forEach((f, i) => {
    const li = el('li'), frame = el('button', 'snap'), im = el('img');
    li.style.cssText = '--i:' + i + ';--tilt:' + tilt[i % 3] + 'deg;--y:' + drop[i % 3] + 'px;--d:' + drift[i % 3] + 'px';
    frame.type = 'button'; frame.setAttribute('aria-haspopup', 'dialog'); frame.setAttribute('aria-label', 'See photo ' + (i + 1) + ' of the ' + p.t + ' being worn, big');
    im.src = shot(f); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.width = 720; im.height = 1080;
    frame.append(im); li.append(frame); row.append(li);
    frame.addEventListener('click', () => openPhoto(i));
  });
  else {
    $('#wild').classList.add('wildstrip--none'); row.remove();
    const strip = $('#wild');      // on Shopify the section carries its own wording for a shirt with no photos yet
    $('#wildH').innerHTML = strip.dataset.noneH || 'Wear it out. <b>Send us proof.</b>';
    $('#wildAsk').textContent = strip.dataset.noneAsk || "Nobody's sent a photo in this one yet. Be the first and you might end up on this page.";
  }

  // the shirt's photos, fanned beside its name like snapshots on a bar (the user, 2026-10-20: moved out of the panel, where it
  // sat in place of a glass). Up to three show, the first on top; a click opens them big and steps through all of them.
  if (snapped) {
    const n = p.w.length;
    const view = photoViewer(p);
    const pin = el('button', 'pdp__shots'), fan = el('span', 'pdp__fan');
    pin.type = 'button'; pin.setAttribute('aria-haspopup', 'dialog');
    pin.setAttribute('aria-label', n > 1 ? 'See ' + n + ' photos of the ' + p.t + ' being worn' : 'See a photo of the ' + p.t + ' being worn');
    p.w.slice(0, 3).forEach((f, i) => { const im = el('img', 'pdp__shot'); im.src = shot(f); im.alt = ''; im.width = 720; im.height = 1080; im.decoding = 'async'; im.style.setProperty('--i', i); fan.append(im); });
    pin.style.setProperty('--n', Math.min(n, 3));
    pin.append(fan, el('span', 'pdp__snaptag', 'In the wild'));
    $('#pdpName').after(pin); $('.pdp__buy').classList.add('pdp__buy--shots'); $('#pdp').classList.add('pdp--shots');
    pin.addEventListener('click', () => view(0));
    openPhoto = view;
  }
}
// the product page's rail: other shirts, switching between ones from the same group and the rest so no one kind runs in a block
const PALETTE = [['#FFC637', '#0E1A2B'], ['#23B8D9', '#0E1A2B'], ['#E3212A', '#FDFDEF'], ['#F97020', '#0E1A2B'], ['#1A324E', '#FDFDEF']];
const GLASSES = ['glass-cubes', 'glass-ball', 'glass-rocks', 'glass-twist', 'glass-square', 'glass-tulip'];
function nextRound(p) {
  const rest = CAT.filter(x => x.h !== p.h), near = rest.filter(x => x.c.some(c => p.c.includes(c))), far = rest.filter(x => !near.includes(x)), mix = [];
  while (near.length || far.length) { if (near.length) mix.push(near.shift()); if (far.length) mix.push(far.shift()); }
  // a shirt with a card on the home page keeps that card's colors; the rest pick their own
  const home = Object.fromEntries(FEATURED.map(f => [f[0], f]));
  // four is plenty here, and the row never opens on a military shirt (the brand is not military-first)
  const four = mix.slice(0, 4), lead = four.findIndex(x => !x.c.includes('military'));
  if (lead > 0) four.unshift(four.splice(lead, 1)[0]);
  return four.map((x, i) => home[x.h] || [x.h, PALETTE[i % 5][0], PALETTE[i % 5][1], PALETTE[i % 5][1], GLASSES[i % 6], null, true]);
}

/* ---------- showcase: a rail of tall cards, a handful of shirts, not the whole catalog ---------- */
// Which shirts show on the home page, in order: shirt, card colour, text colour, then up to three pop-out pictures
// that jump out from behind the shirt on rollover (lower left, upper right, centred behind). On Shopify these four
// things become settings on each card in the theme editor.
// Art that shows on rollover: a helmet skull that springs up through the collar so the shirt gets a head,
// and a whiskey glass in front of the shirt at the lower left. Both are drawn in two colours (lines and fill).
const ART = asset('popouts/');
// shirt, card colour, text colour, colour for a shape behind the shirt, which glass, and an optional shape behind the shirt
const FEATURED = fromPage('rail', null) || [
  ['lets-get-flocked-up', '#FFC637', '#0E1A2B', '#0E1A2B', 'glass-cubes'],
  ['tailgatin-gator-style', '#23B8D9', '#0E1A2B', '#FDFDEF', 'glass-ball'],
  ['storm-the-cooler', '#E3212A', '#FDFDEF', '#FDFDEF', 'glass-rocks'],
  ['stirred-slowly', '#F97020', '#0E1A2B', '#FDFDEF', 'glass-twist'],
  ['getting-tail', '#1A324E', '#FDFDEF', '#FDFDEF', 'glass-square'],
  ['come-in-hot', '#FFC637', '#0E1A2B', '#0E1A2B', 'glass-tulip'],
  ['trail-rated', '#F97020', '#0E1A2B', '#FDFDEF', 'glass-cubes'],
  ['chutes-up', '#23B8D9', '#0E1A2B', '#FDFDEF', 'glass-rocks']
];
// shapes that can sit behind a shirt. "rays" and "ring" are drawn lines, the rest are solid.
const SHAPES = {"rays": "M178.0 100.0L195.0 100.0M172.9 139.7L186.1 146.9M142.3 165.5L154.8 184.9M118.5 180.9L123.1 201.4M78.9 175.1L74.3 191.4M42.0 159.4L31.6 170.1M29.7 133.8L9.0 143.8M17.1 95.9L-3.9 94.8M33.5 59.3L19.0 50.4M48.3 35.1L38.9 23.4M86.5 23.2L82.5 0.5M126.5 21.3L133.1 1.4M148.6 39.0L159.2 25.7M176.5 67.8L190.3 61.9", "sun": "M159.8 94.6L200.0 100.0L159.8 105.4ZM158.0 115.3L184.6 130.8L154.3 125.5ZM149.3 134.2L176.6 164.3L142.3 142.6ZM134.6 149.0L145.0 177.9L125.2 154.5ZM115.7 157.9L117.4 198.5L105.0 159.8ZM95.0 159.8L84.4 188.6L84.3 157.9ZM74.8 154.5L50.0 186.6L65.4 149.0ZM57.7 142.6L31.1 157.9L50.7 134.2ZM45.7 125.5L6.0 134.2L42.0 115.3ZM40.2 105.4L10.0 100.0L40.2 94.6ZM42.0 84.7L6.0 65.8L45.7 74.5ZM50.7 65.8L31.1 42.1L57.7 57.4ZM65.4 51.0L50.0 13.4L74.8 45.5ZM84.3 42.1L84.4 11.4L95.0 40.2ZM105.0 40.2L117.4 1.5L115.7 42.1ZM125.2 45.5L145.0 22.1L134.6 51.0ZM142.3 57.4L176.6 35.7L149.3 65.8ZM154.3 74.5L184.6 69.2L158.0 84.7ZM162 100A62 62 0 1 1 38 100A62 62 0 1 1 162 100Z", "pow": "M190.2 81.7L172.9 103.0L197.9 128.5L159.7 134.6L172.7 170.1L139.5 162.6L131.5 194.9L105.5 169.8L84.0 197.7L74.0 160.7L41.0 178.3L44.9 144.8L12.3 141.5L34.3 113.3L4.1 96.0L30.9 79.9L17.8 52.4L51.0 52.8L49.9 20.5L77.0 30.7L92.6 7.3L111.2 31.9L136.2 15.4L144.5 40.9L179.1 35.6L163.3 70.1Z", "badge": "M188.0 100.0A13 13 0 0 1 181.3 133.7A13 13 0 0 1 162.2 162.2A13 13 0 0 1 133.7 181.3A13 13 0 0 1 100.0 188.0A13 13 0 0 1 66.3 181.3A13 13 0 0 1 37.8 162.2A13 13 0 0 1 18.7 133.7A13 13 0 0 1 12.0 100.0A13 13 0 0 1 18.7 66.3A13 13 0 0 1 37.8 37.8A13 13 0 0 1 66.3 18.7A13 13 0 0 1 100.0 12.0A13 13 0 0 1 133.7 18.7A13 13 0 0 1 162.2 37.8A13 13 0 0 1 181.3 66.3A13 13 0 0 1 188.0 100.0Z", "splash": "M100 14c20-2 26 16 42 20s34-6 42 12-10 28-6 44 22 24 14 42-30 8-44 20-10 36-30 40-28-18-46-20-36 12-50-4 6-32 0-48-28-22-22-42 28-14 40-28 16-34 36-36zM176 30a9 9 0 1 0 .1 0zM26 150a7 7 0 1 0 .1 0zM172 168a6 6 0 1 0 .1 0z", "ring": "M183.2 125.7L177.1 137.9L169.3 148.9L160.3 158.7L150.4 167.3L139.2 174.3L126.9 179.0L114.0 181.1L101.1 181.0L88.6 179.5L76.1 177.3L63.4 174.4L50.7 170.0L38.6 163.1L28.7 153.4L21.8 141.2L18.4 127.8L17.8 114.2L18.7 101.2L20.4 88.5L22.7 76.1L26.4 63.8L32.0 52.0L39.9 41.6L49.7 32.8L60.8 25.7L72.7 20.0L85.4 15.6L98.8 13.1L112.5 13.2L125.7 16.8L137.6 23.6L147.5 32.7L155.7 42.7L163.2 52.7L170.4 62.9L177.5 73.6L183.3 85.6L186.7 98.8L186.7 112.5L183.2 125.7M88.1 191.6L73.8 188.9L60.0 184.3L46.8 177.7L34.9 168.8L25.3 157.5L18.6 144.4L14.7 130.4L12.8 116.3L12.2 102.4L12.2 88.6L13.3 74.5L16.3 60.3L22.1 46.6L30.9 34.6L42.2 24.9L55.2 17.8L69.0 12.9L83.1 9.7L97.4 8.4L111.8 9.1L125.8 12.3L138.9 18.1L150.7 25.9L161.4 35.1L171.1 45.2L180.1 56.3L188.0 68.7L193.7 82.5L196.1 97.3L194.7 112.3L189.8 126.4L182.5 139.2L173.9 150.6L164.5 161.0L154.5 170.7L143.3 179.4L130.7 186.2L117.0 190.6L102.6 192.3L88.1 191.6"};
const LINE_SHAPES = ['rays', 'ring'];
// pop lines either side of the helmet: three short strokes a side, drawn from the head outward
const POW = '<svg class="fx-pow" viewBox="0 0 100 60" aria-hidden="true">' + [
  'M72.5 11 82.5 5.5', 'M75 20.5 85 19.3', 'M75 30 83 32.4',
  'M27.5 11.5 17 6', 'M25 21 15.5 20.4', 'M25.5 30.5 17.5 33.4'
].map((d, n) => '<path pathLength="1" style="--n:' + (n % 3) + '" d="' + d + '"/>').join('') + '</svg>';
const rail = $('#rail'), railBar = $('#railBar'), railPrev = $('#railPrev'), railNext = $('#railNext');
let openSizes = null;

// one shirt card, used by the rails and by the page of every shirt
function shirtCard([h, c, on, tint, glass, shape, auto], i) {
  const p = BY[h]; if (!p) return null;
  const url = productUrl(p.h);
  const card = el('article', 'pcard'); card.style.setProperty('--c', c); card.style.setProperty('--on', on); card.style.setProperty('--i', i % 4);
  const name = el('h3', 'pcard__name'), nameLink = el('a', '', p.t); nameLink.href = url; name.append(nameLink);
  const picLink = el('a', 'pcard__pic'); picLink.href = url; picLink.tabIndex = -1; picLink.setAttribute('aria-hidden', 'true');
  const im = el('img'); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.width = 600; im.height = 600; im.draggable = false; im.src = pic(p.f, 600);
  const fx = el('span', 'pcard__fx');
  card.style.setProperty('--shape', tint || on);
  if (shape && SHAPES[shape]) fx.insertAdjacentHTML('beforeend', '<svg class="fx-shape' + (LINE_SHAPES.includes(shape) ? ' fx-shape--line' : '') + '" viewBox="0 0 200 200"><path d="' + SHAPES[shape] + '"/></svg>');
  const mask = (node, file) => { const url = "url('" + ART + file + "')"; node.style.webkitMaskImage = url; node.style.maskImage = url; return node; };
  // each piece of art is two layers of the same drawing: a filled-in backing, then the line work on top
  const art = (cls, fill, line) => { const n = el('span', 'fx-art ' + cls); n.append(mask(el('i', 'fx-icon fx-art__fill'), fill), mask(el('i', 'fx-icon fx-art__line'), line)); return n; };
  // the head lives in front of the shirt but is cut to the neck opening, so it comes up through the collar
  const neck = el('span', 'pcard__neck');
  neck.append(art('fx-head', 'skull-head-solid.svg', 'skull-head.svg'));
  // the drink sits in front of the shirt
  const front = el('span', 'pcard__front');
  front.insertAdjacentHTML('beforeend', POW);
  if (glass) front.append(art('fx-glass', glass + '-solid.png', glass + '.svg'));
  const stage = el('span', 'pcard__stage');
  stage.append(fx, im, neck, front);
  picLink.append(stage);

  const foot = el('div', 'pcard__foot');
  const add = el('button', 'pbtn pbtn--add'); add.type = 'button'; add.setAttribute('aria-expanded', 'false');
  const addLabel = roll('Add to my tab');
  add.append(addLabel, el('span', '', money(p.p)));
  const sizes = el('div', 'psizes'); sizes.hidden = true;
  const hint = el('p', '', 'Pick your size'); sizes.append(hint);
  p.v.forEach(([title, id], n) => {
    const b = el('button', '', title); b.type = 'button'; b.style.setProperty('--n', n); b.setAttribute('aria-label', p.t + ', size ' + title + ', add to my tab');
    b.addEventListener('click', async () => {
      b.disabled = true; b.classList.add('is-pouring'); hint.textContent = 'Pouring ' + title + '...';      // the size buttons are too small for the word, so the line above them says it
      try { await Cart.add(id, p, title); toggle(false); Cart.open(); }
      catch (e) { hint.textContent = "That didn't go through. Try again."; }
      b.disabled = false; b.classList.remove('is-pouring');
    });
    sizes.append(b);
  });
  const view = el('a', 'pbtn pbtn--view'); view.href = url; view.append(roll('View shirt'));
  view.insertAdjacentHTML('beforeend', '<svg aria-hidden="true"><use href="#arrow"/></svg>');
  function toggle(on) {
    if (on && openSizes && openSizes !== toggle) openSizes(false);
    sizes.hidden = !on; view.hidden = on; add.setAttribute('aria-expanded', on); addLabel.set(on ? 'Never mind' : 'Add to my tab');
    card.classList.toggle('open', on);
    hint.textContent = 'Pick your size'; openSizes = on ? toggle : null;
  }
  add.addEventListener('click', () => toggle(sizes.hidden));
  foot.append(sizes, add, view);
  // the price, always showing at the foot of the card; it steps aside when the buttons come up
  const price = el('p', 'pcard__price', money(p.p)); price.setAttribute('aria-hidden', 'true');
  card.append(name, picLink, foot, price);
  // the shirt leans a little toward the cursor
  let lean = null;
  card.addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse' || calm.matches || lean) return;
    lean = requestAnimationFrame(() => { lean = null; const r = card.getBoundingClientRect(); card.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(2)); card.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(2)); });
  });
  card.addEventListener('pointerleave', () => { card.style.setProperty('--mx', 0); card.style.setProperty('--my', 0); });
  // a card with no colour of its own picks the one that stands off most from its shirt
  if (auto) { card.dataset.auto = p.f; }
  return card;
}

if (rail) {      // a page with no rail (Questions, About, every shirt) skips all of this
// the rail never ends: the row of cards is laid out three times over, and whenever the rail comes to rest off the middle row
// the script hops it back on. Every row is the same, so nothing is seen to move.
// The product page is the exception: four shirts in one plain row that ends (the user, 2026-10-16: no endless scrolling there).
const SHOWN = PDP ? nextRound(PDP) : FEATURED, LOOP = !PDP, LAPS = LOOP ? [0, 1, 2] : [1];
// a row that loops has no start or end, so it gets no progress bar (it only jumped back to the start each lap). With a mouse the
// arrows and the drift say there is more; on touch screens a "Swipe for more" hint does, and it fades for good after the first swipe.
{ const box = rail.closest('.show'); if (LOOP) box.classList.add('show--loop'); box.classList.add('show--hint'); swipeHint(rail, 'show__swipe', h => $('.show__ctrl', box).append(h)); }
LAPS.forEach(lap => { let prevC = ''; SHOWN.forEach((entry, i) => {
  // a navy card fades into these dark rows, and two cards side by side should never match (Next round puts shirts together
  // that sit apart on the home page): either way that shirt picks its own color instead (2026-10-27)
  const c = (entry[1] || '').toUpperCase(), repick = c === '#1A324E' || (c && c === prevC);
  const card = shirtCard(repick ? [entry[0], '#F97020', '#0E1A2B', '#0E1A2B', entry[4], entry[5], true] : entry, i); if (!card) return;
  prevC = repick || entry[6] ? '' : c;
  card.dataset.lap = lap;
  // the two spare rows are for the eye and the mouse only: screen readers and the Tab key get each shirt once
  if (lap !== 1) { card.setAttribute('aria-hidden', 'true'); $$('a,button', card).forEach(n => { n.tabIndex = -1; }); }
  rail.append(card);
}); });

LAPS.forEach(lap => stageRow($$('.pcard[data-auto][data-lap="' + lap + '"]', rail), card => card.dataset.auto));      // row by row, so all three come out the same

// arrows, progress bar, and click-and-drag with a mouse
const railStep = () => { const c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 14 : 300; };
const railLap = () => railStep() * rail.children.length / LAPS.length;      // the width of one full row of cards
const railJump = x => rail.scrollTo({ left: x, behavior: 'instant' });
let railGoal = null, railGoalTimer = null, railHeld = false, railRest = null, railW = 0;
function railState() {
  if (!LOOP) {      // a row that ends: the bar runs from start to end, and arrows and bar step aside when every card fits
    const max = rail.scrollWidth - rail.clientWidth; railBar.style.setProperty('--s', max > 1 ? (rail.scrollLeft / max * .75).toFixed(4) : 0);
    rail.closest('.show').classList.toggle('show--all', max <= 1); return;
  }
  const w = railLap(); railBar.style.setProperty('--s', (((rail.scrollLeft % w) + w) % w / w).toFixed(4));
}
function railWrap() {
  if (railHeld || !LOOP) return;
  const w = railLap(), x = rail.scrollLeft, hop = x < w * .75 ? w : x >= w * 1.75 ? -w : 0;
  if (!hop) return;
  railJump(x + hop); if (railGoal !== null) railGoal += hop;
}
// a new screen size changes the width of a card: stay on the same card
function railFit() { const w = railLap(); if (railW && Math.abs(w - railW) > .5) railJump(rail.scrollLeft / railW * w); railW = w; railState(); }
// fast repeated clicks add up instead of restarting from wherever the rail happens to be mid-slide
function railNudge(dir) {
  const step = railStep(), max = rail.scrollWidth - rail.clientWidth;
  const from = railGoal === null ? rail.scrollLeft : railGoal;
  railGoal = clamp(Math.round((from + dir * step) / step) * step, 0, max);
  rail.scrollTo({ left: railGoal, behavior: calm.matches ? 'auto' : 'smooth' });
  clearTimeout(railGoalTimer); railGoalTimer = setTimeout(() => { railGoal = null; }, 700);
}
railPrev.addEventListener('click', () => { driftHold(4000); railNudge(-1); });
railNext.addEventListener('click', () => { driftHold(4000); railNudge(1); });
rail.addEventListener('scroll', () => { railState(); clearTimeout(railRest); railRest = setTimeout(railRested, 140); }, { passive: true });
// a finger on the rail owns it: no hopping until it lets go
rail.addEventListener('touchstart', () => { railHeld = true; userScroll = true; }, { passive: true });
['touchend', 'touchcancel'].forEach(t => rail.addEventListener(t, () => { railHeld = false; driftHold(4000); clearTimeout(railRest); railRest = setTimeout(railRested, 140); }, { passive: true }));
addEventListener('resize', railFit, { passive: true });
if (LOOP) railJump(railLap()); railFit();      // start on the middle row

// the rail drifts slowly to the left by itself, like a conveyor belt. It stops the moment a mouse is over it, a finger is on it,
// a card's sizes are open or the keyboard is in it, waits a few seconds after a tap or an arrow click, and rests while it is
// off screen or the tab is hidden. With reduced motion it never moves. While it can drift, the browser's own snapping is off
// (it would fight the slide), so after a swipe the script eases the row to the nearest card itself.
const DRIFT = 28;      // pixels a second
// the drift is for screens with a mouse. Phones and tablets swipe, and a card sliding off mid-read just looks cut off there.
const driftOK = LOOP ? matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)') : { matches: false };
let driftPos = 0, driftLast = 0, driftOn = false, driftSeen = false, driftHover = false, driftUntil = 0, userScroll = false;
function driftHold(ms) { driftUntil = Math.max(driftUntil, performance.now() + ms); }
function railRested() {
  railWrap();
  if (!userScroll || railHeld || driftOn || !rail.classList.contains('rail--free')) return;
  userScroll = false; const step = railStep(); rail.scrollTo({ left: Math.round(rail.scrollLeft / step) * step, behavior: 'smooth' });
}
function driftTick(now) {
  requestAnimationFrame(driftTick);
  const f = document.activeElement, keys = f && rail.contains(f) && f.matches(':focus-visible');
  const go = driftOK.matches && driftSeen && !driftHover && !railHeld && !openSizes && !keys && dragX === null && !document.hidden && !calm.matches && now > driftUntil;
  rail.classList.toggle('rail--free', !calm.matches && driftOK.matches);
  if (!go) { driftOn = false; return; }
  if (!driftOn) { driftOn = true; driftPos = rail.scrollLeft; driftLast = now; return; }      // setting off again: start from wherever the rail is now
  const w = railLap(); driftPos += DRIFT * Math.min(64, now - driftLast) / 1000; driftLast = now;
  if (driftPos >= w * 1.75) driftPos -= w;      // past the middle row: hop back a row, which looks the same
  rail.scrollLeft = driftPos;
}
const railBox = rail.parentElement;
railBox.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') driftHover = true; });
railBox.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { driftHover = false; driftHold(1500); } });
rail.addEventListener('wheel', e => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { userScroll = true; driftHold(4000); } }, { passive: true });
new IntersectionObserver(es => es.forEach(e => { driftSeen = e.isIntersecting; }), { threshold: 0.2 }).observe(rail);
requestAnimationFrame(driftTick);
let dragX = null, dragFrom = 0, dragged = false;
rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button || e.target.closest('button')) return; dragX = e.clientX; dragFrom = rail.scrollLeft; dragged = false; });
addEventListener('pointermove', e => {
  if (dragX === null) return;
  const dx = e.clientX - dragX;
  if (!dragged && Math.abs(dx) > 6) { dragged = true; railHeld = true; rail.classList.add('drag'); }
  if (dragged) {
    // dragged a long way: hop a row without letting go
    const w = railLap(); let x = dragFrom - dx;
    if (LOOP && x < w * .5) { dragFrom += w; x += w; } else if (LOOP && x > w * 2) { dragFrom -= w; x -= w; }
    rail.scrollLeft = x;
  }
});
addEventListener('pointerup', () => {
  if (dragX === null) return; dragX = null;
  railHeld = false;
  if (dragged) { rail.classList.remove('drag'); const step = railStep(); rail.scrollTo({ left: Math.round(rail.scrollLeft / step) * step, behavior: calm.matches ? 'auto' : 'smooth' }); }
});
rail.addEventListener('click', e => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
rail.addEventListener('keydown', e => { if (e.target !== rail) return; if (e.key === 'ArrowRight') { e.preventDefault(); railNext.click(); } if (e.key === 'ArrowLeft') { e.preventDefault(); railPrev.click(); } });
}

/* ---------- hero: a shirt on show that changes by itself, or when you pick one. The shirt swaps, the color floods in,
   its name and price ride on a tag, and the mascot says its one-liner ---------- */
const crew = $('#crew'), flood = $('#flood'), imgA = $('#heroA'), imgB = $('#heroB');
if (crew && hero && PICKS.length) {
  const tag = $('#heroTag'), say = $('#heroSay'), link = $('#heroShirt'), big = $('#heroBig'), panel = flood.parentElement;
  const again = (n, cls) => { if (!n) return; n.classList.remove(cls); void n.offsetWidth; n.classList.add(cls); };
  // the headline's letters tumble in one by one
  if (big && !calm.matches) {
    const words = big.getAttribute('aria-label').split(' '); let n = 0; big.textContent = '';
    words.forEach(w => { const word = el('span', 'pdp__word'); word.setAttribute('aria-hidden', 'true'); [...w].forEach(ch => { const l = el('span', 'pdp__ch', ch); l.style.setProperty('--n', n); l.style.setProperty('--r', ((n * 37) % 44 - 22) + 'deg'); n++; word.append(l); }); big.append(word, ' '); });
  }
  let rest = null;
  const buttons = PICKS.map((c, i) => {
    const p = BY[c.shirt], b = el('button'), face = el('span'), im = el('img');
    b.type = 'button'; b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', p.t);
    im.alt = ''; im.width = 50; im.height = 50; im.src = pic(p.f, 160); face.append(im); b.append(face);
    b.insertAdjacentHTML('beforeend', '<svg class="crew__ring" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="30" pathLength="1"/></svg>');
    // picked one yourself: the timer steps back so you can look, and picks up again from that shirt after twelve quiet seconds
    b.addEventListener('click', () => { crew.classList.remove('crew--auto'); clearTimeout(rest); if (!calm.matches) rest = setTimeout(() => crew.classList.add('crew--auto'), 12000); show(i, b); });
    crew.append(b); return b;
  });
  let at = -1, flooding = null;
  function swap(p) {
    const next = imgA.classList.contains('show') ? imgB : imgA, prev = next === imgA ? imgB : imgA;
    next.alt = ''; next.src = pic(p.f, heroPicW()); next.classList.add('show'); prev.classList.remove('show');
  }
  function show(i, from) {
    if (i === at) return;
    const c = PICKS[i], p = BY[c.shirt], first = at < 0; at = i;
    buttons.forEach((b, k) => b.setAttribute('aria-pressed', k === i));
    swap(p);
    $('#heroName').textContent = p.t; $('#heroPrice').textContent = money(p.p); tag.href = link.href = productUrl(p.h); tag.setAttribute('aria-label', p.t + ', ' + money(p.p) + ', view shirt');
    say.textContent = p.l || '';
    if (!first) { again(tag, 'is-new'); again(say, 'is-new'); }
    const coming = BY[PICKS[(i + 1) % PICKS.length].shirt]; if (coming) { const pre = new Image(); pre.src = pic(coming.f, heroPicW()); }      // have the next shirt's picture ready
    hero.style.setProperty('--on', c.on); topbar.style.setProperty('--on', c.on); topbar.style.setProperty('--under', c.color);   // words switch color right away, the panel floods in behind them
    const settle = () => { hero.style.setProperty('--panel', c.color); flood.classList.remove('go-flood'); flood.style.background = ''; flooding = null; document.querySelector('meta[name=theme-color]').content = c.color; };
    if (!from || calm.matches) return settle();
    if (flooding) { clearTimeout(flooding); hero.style.setProperty('--panel', flood.dataset.to); flood.classList.remove('go-flood'); }
    const box = panel.getBoundingClientRect(), b = from.getBoundingClientRect();
    const k = panel.offsetWidth / box.width;   // the panel may be mid-shrink
    flood.style.setProperty('--fx', ((b.left + b.width / 2 - box.left) * k) + 'px');
    flood.style.setProperty('--fy', ((b.top + b.height / 2 - box.top) * k) + 'px');
    flood.style.background = c.color; flood.dataset.to = c.color;
    flood.style.setProperty('--panel', c.color);      // so palm art inside the flood (Shopify) arrives already in the new color
    void flood.offsetWidth;
    flood.classList.add('go-flood');
    flooding = setTimeout(settle, 820);
  }
  // the timer is the red ring on the button: when it closes, on to the next shirt
  crew.addEventListener('animationend', e => { if (e.animationName !== 'crew-ring' || !crew.classList.contains('crew--auto')) return; const n = (at + 1) % PICKS.length; show(n, buttons[n]); });
  new IntersectionObserver(es => es.forEach(e => hero.classList.toggle('hero--away', e.intersectionRatio < 0.5)), { threshold: [0, 0.5, 1] }).observe(hero);
  // the mascot is placed off the box of shirts (his glass rests on its top edge), so the stylesheet needs the box's real size
  const box = crew.parentElement;
  const fit = () => { const k = panel.offsetWidth / (panel.getBoundingClientRect().width || 1); panel.style.setProperty('--bw', (box.getBoundingClientRect().width * k).toFixed(1) + 'px'); panel.style.setProperty('--bh', (box.getBoundingClientRect().height * k).toFixed(1) + 'px'); };
  // the speech bubble sits above the skeleton's head, and on most laptops it ran over the shirt's sleeve (the user, 2026-10-27). It
  // slides right, clear of the shirt, as far as the panel allows (narrowing to no less than 200px), and its tail follows his head.
  // Measured in the panel's own pixels (it shrinks as the page scrolls). Phones lay the hero out differently and are left alone.
  const buddy = $('#heroBuddy');
  const placeSay = () => {
    ['right', 'width'].forEach(x => say.style.removeProperty(x)); say.classList.remove('is-placed');
    if (innerWidth <= 900 || !buddy || getComputedStyle(say).display === 'none') return;
    const k = panel.offsetWidth / (panel.getBoundingClientRect().width || 1), p = panel.getBoundingClientRect(), s = link.getBoundingClientRect();
    const shirtRight = (s.right - p.left) * k - s.width * k * .015, left = say.offsetLeft, w = say.offsetWidth, room = panel.offsetWidth - 18;
    if (shirtRight + 12 <= left) return;
    const width = Math.max(200, Math.min(w, room - (shirtRight + 12))), newLeft = Math.min(shirtRight + 12, room - width);
    say.style.width = width + 'px'; say.style.right = (panel.offsetWidth - newLeft - width) + 'px';
    const head = buddy.offsetLeft + buddy.offsetWidth * .6;
    say.style.setProperty('--tail-x', Math.round(Math.min(Math.max(head - newLeft - 9, 22), width - 40)) + 'px'); say.classList.add('is-placed');
  };
  const fitAll = () => { fit(); requestAnimationFrame(placeSay); };
  fitAll(); addEventListener('resize', fitAll, { passive: true });
  show(0);
  if (!calm.matches && PICKS.length > 1) crew.classList.add('crew--auto');
}

/* ---------- every shirt: the whole catalog as a grid of the same cards ---------- */
const grid = $('#grid');
if (grid) {
  // deal the shirts out one group at a time, so no one kind (military, animals, drinks) sits in a block
  // on Shopify a collection page names its own shirts (data-handles); the page of every shirt shows them all
  const pool = grid.dataset.handles ? grid.dataset.handles.split(',').map(h => BY[h]).filter(Boolean) : CAT;
  const piles = {}; pool.forEach(p => { const k = (p.c && p.c[0]) || ''; (piles[k] = piles[k] || []).push(p); });
  const stacks = Object.values(piles), dealt = [];
  while (stacks.some(s => s.length)) stacks.forEach(s => { if (s.length) dealt.push(s.shift()); });
  // on the store the collection's own hand-sorted order wins (the user sorted it to keep military shirts apart, 2026-10-28):
  // dealing four kinds into four columns had stacked every military shirt in one column. The preview's list isn't sorted, so it still deals.
  const order = window.BB_ASSETS ? pool.slice() : dealt;
  // no navy cards here: on this dark page they faded into the background. Orange takes navy's place (the user, 2026-10-20).
  const LOUD = PALETTE.filter(x => x[0] !== '#1A324E');
  const cards = order.map((p, i) => {
    const card = shirtCard([p.h, LOUD[i % 4][0], LOUD[i % 4][1], LOUD[i % 4][1], GLASSES[i % 6], null, true], i);
    grid.append(card); return card;
  });
  const tile = $('#gridCoaster'); if (tile) grid.insertBefore(tile, cards[9] || null);      // the coaster sits in the middle, after the ninth shirt, to break up the grid
  // each card takes the loud color that stands off most from its shirt, skipping the color of the card to its left and the one above
  const ranks = []; let colsNow = 0, ready = 0;
  function paint() {
    const cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    if (ready < cards.length || cols === colsNow) return;
    colsNow = cols; const got = [];
    const spots = [...grid.children];      // places in the grid, counting the coaster, so "left" and "above" are true neighbors
    cards.forEach((card, k) => {
      const at = spots.indexOf(card), no = [at % cols ? got[at - 1] : null, got[at - cols]], s = ranks[k].find(x => !no.includes(x.c));
      got[at] = s ? s.c : card.style.getPropertyValue('--c');
      if (s) { card.style.setProperty('--c', s.c); card.style.setProperty('--on', s.on); card.style.setProperty('--shape', s.on); }
    });
  }
  cards.forEach((card, k) => stageColor(card.dataset.auto, (best, ranked) => { ranks[k] = noNavy(ranked); ready++; paint(); }));      // orange moves into navy's rank
  addEventListener('resize', paint, { passive: true });
  const count = $('#gridCount'); if (count) count.textContent = cards.length;
}

/* ---------- the Questions page: every answer has its own link (faq.html#returns on the preview, /pages/questions#returns on
   the store) that opens the page on that answer, already open. Opening an answer puts its link in the address bar to copy. ---------- */
if (document.body.classList.contains('page-faq') || document.body.classList.contains('page-policies')) {   // the Policies page works the same way
  const qs = $$('details.qa[id]');
  const openHash = () => {
    const q = qs.find(d => '#' + d.id === location.hash); if (!q) return;
    q.open = true;
    const go = () => q.scrollIntoView({ block: 'start' });      // its scroll-margin keeps it clear of the top bar
    requestAnimationFrame(go); addEventListener('load', () => setTimeout(go, 50), { once: true });
  };
  openHash(); addEventListener('hashchange', openHash);
  qs.forEach(d => d.addEventListener('toggle', () => { if (d.open) history.replaceState(null, '', '#' + d.id); else if (location.hash === '#' + d.id) history.replaceState(null, '', location.pathname + location.search); }));
}

// in the local preview the "all shirts" links open the preview's own page of every shirt
if (!ON_STORE) $$('a[href^="' + STORE + '/collections/every-damn-shirt"]').forEach(a => { a.href = 'shirts.html'; });
if (!ON_STORE) $$('a[href^="' + STORE + '/pages/contact"]').forEach(a => { a.href = 'contact.html' + new URL(a.href).search; });      // keeps ?topic=
// in the local preview, shirt links written into the page open the preview's own product page instead of the live store
if (!ON_STORE) $$('a[href^="' + STORE + '/products/"]').forEach(a => { a.href = productUrl(a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0]); });


/* ---------- Shopify's theme editor: when a section is changed there, the page is drawn fresh so every effect sets itself up again ---------- */
if (window.Shopify && window.Shopify.designMode) ['shopify:section:load', 'shopify:section:reorder', 'shopify:block:select'].slice(0, 2).forEach(t => document.addEventListener(t, () => location.reload()));
})();
